/* Klaviyo teaser guard. Declining the 10% signup used to leave an 84x84
   "GET 10% OFF!" badge that survived reloads and sat on top of the Home tab.
   Klaviyo records the decline itself under viewedForms.modal.disabledForms
   but never populates disabledTeasers, which is the whole bug. So read their
   own record rather than intercepting their buttons: it is synchronous at
   load, survives reloads and new sessions, and does not depend on their
   markup. Paired with the .sz-kl-declined rule in assets/sz-rd.css.
   Also fires after a SUCCESSFUL signup, which is correct — a subscriber
   should not keep being offered the signup discount. */
(function () {
  function declined() {
    try {
      var d = JSON.parse(localStorage.getItem('klaviyoOnsite') || '{}');
      var modal = d && d.viewedForms && d.viewedForms.modal;
      var forms = modal && modal.disabledForms;
      return !!(forms && Object.keys(forms).length);
    } catch (e) {
      return false;
    }
  }
  function sync() {
    if (declined()) document.documentElement.classList.add('sz-kl-declined');
  }
  sync();
  // Klaviyo writes the record as it closes the modal, so re-check just after a
  // click inside its UI — the badge then goes on this page view, not the next.
  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('[class*="kl-private"]')) setTimeout(sync, 300);
    },
    true
  );
})();

/* STOCK-CAP-1012 (owner 2026-10-12 "Yes set cap"): a buy-now line can hold at most what is in stock. The product page
   caps its own stepper (sections/sz-pm-product.liquid); this is the check for the bag panel and the bag page, and the
   safety net for any other way in (a card's quick add, an old bag). Stock comes from sections/sz-bag-stock.liquid via
   the Section Rendering API, because /cart.js carries no stock. Pre-order lines (a selling plan) are never capped.
   enforce(cart) trims any buy-now line over stock (later lines of the same grade first), and resolves to
   { cart, changed, note, caps: { lineKey: { max, stock } } }. */
window.szStock = (function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function stockMap() {
    return fetch(root + '?sections=sz-bag-stock', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var html = j && j['sz-bag-stock']; if (!html) return null;
        var box = document.createElement('div'); box.innerHTML = html;
        var el = box.querySelector('[data-sz-bag-stock]');
        return el ? JSON.parse(el.textContent) : null;
      })
      .catch(function () { return null; });
  }
  function name(it) { return it.product_title + (it.variant_title && it.variant_title !== 'Default Title' ? ' (' + it.variant_title + ')' : ''); }
  function plan(cart, stock) {
    var used = {}, fixes = [], caps = {};
    ((cart && cart.items) || []).forEach(function (it) {
      if (it.selling_plan_allocation) return;
      var s = stock[String(it.variant_id)]; if (!s) return;
      var left = Math.max(0, s.stock - (used[it.variant_id] || 0)), keep = Math.min(it.quantity, left);
      used[it.variant_id] = (used[it.variant_id] || 0) + keep;
      caps[it.key] = { max: left, stock: s.stock };
      if (it.quantity > left) fixes.push({ key: it.key, quantity: keep, name: name(it), stock: s.stock, variant: String(it.variant_id) });
    });
    // JS-BAG-1014: a deal can split one grade over several lines, so the note states the grade's TOTAL left in the
    // bag ("so your bag now has 200"), not the one trimmed line ("129").
    fixes.forEach(function (f) { f.total = used[f.variant] || 0; });
    return { fixes: fixes, caps: caps };
  }
  function note(fixes) {
    var seen = {};
    return fixes.filter(function (f) { if (seen[f.variant]) return false; seen[f.variant] = 1; return true; }).map(function (f) {
      var total = f.total != null ? f.total : f.quantity;
      return total > 0
        ? 'We have ' + f.stock + ' of ' + f.name + ' in stock, so your bag now has ' + total + '.'
        : f.name + ' sold out while it was in your bag, so we took it out.';
    }).join(' ') + ' For more, pre-order from its page.';
  }
  function change(key, quantity) {
    return fetch(root + 'cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    }).then(function (r) { if (!r.ok) throw new Error('change failed'); return r.json(); });
  }
  function enforce(cart) {
    if (!cart || !cart.items || !cart.items.length) return Promise.resolve({ cart: cart, changed: false, note: '', caps: {} });
    return stockMap().then(function (stock) {
      if (!stock) return { cart: cart, changed: false, note: '', caps: {} };
      var p = plan(cart, stock);
      if (!p.fixes.length) return { cart: cart, changed: false, note: '', caps: p.caps };
      var chain = Promise.resolve(cart);
      p.fixes.forEach(function (f) { chain = chain.then(function () { return change(f.key, f.quantity); }); });
      return chain.then(function (c) { return { cart: c, changed: true, note: note(p.fixes), caps: plan(c, stock).caps }; })
        .catch(function () { return { cart: cart, changed: false, note: '', caps: p.caps }; });
    });
  }
  /* A savings nudge ("Add 3 more to save 5%") is hidden when stock cannot cover the extra shrimp it asks for. */
  function trimNudges(scope, room) {
    scope.querySelectorAll('.sz-rd-nudge').forEach(function (n) {
      var m = /Add (\d+) more/.exec(n.textContent || '');
      if (m && +m[1] > room) n.hidden = true;
    });
  }
  return { enforce: enforce, trimNudges: trimNudges };
})();

/* Klaviyo stuck-popup guard (2026-09-05). Measured on the live homepage while
   logged in: Klaviyo's signup modal wrapper (div.kl-private-reset-css-*,
   position:fixed, full viewport, z-index 90000) sat at opacity 0 with its card
   still translated 44px — the entrance animation never finished — while
   <body class="klaviyo-prevent-body-scroll"> had locked scrolling. The page
   looked normal and the mouse did nothing: a transparent lid over the store.
   Klaviyo owns that markup and animation; we own whether the shop stays usable.
   After a wrapper has been invisible for 1.5 s, clicks pass through it and the
   body unlocks. If Klaviyo later does fade it in, the override lifts so the
   popup works as designed. Nothing here runs while Klaviyo behaves. */
(function () {
  var since = new WeakMap();
  var muted = new WeakMap();
  function lids() {
    var out = [];
    var all = document.querySelectorAll('div[class*="kl-private-reset-css"]');
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (getComputedStyle(el).position !== 'fixed') continue;
      var r = el.getBoundingClientRect();
      if (r.width >= innerWidth * 0.9 && r.height >= innerHeight * 0.9) out.push(el);
    }
    return out;
  }
  function tick() {
    var now = Date.now();
    lids().forEach(function (el) {
      var cs = getComputedStyle(el);
      var invisible = parseFloat(cs.opacity) < 0.05 && cs.display !== 'none' && cs.visibility !== 'hidden';
      if (!invisible) {
        since.delete(el);
        if (muted.get(el)) { el.style.removeProperty('pointer-events'); muted.delete(el); }
        return;
      }
      if (muted.get(el)) return;
      if (!since.has(el)) { since.set(el, now); return; }
      if (now - since.get(el) < 1500) return;
      el.style.setProperty('pointer-events', 'none', 'important');
      muted.set(el, true);
      /* Klaviyo has used both spellings; the live body carries -scrolling (measured 2026-09-08). */
      document.body.classList.remove('klaviyo-prevent-body-scroll', 'klaviyo-prevent-body-scrolling');
      if (document.body.style.overflow === 'hidden') document.body.style.overflow = '';
    });
  }
  var runs = 0;
  var timer = setInterval(function () {
    tick();
    if (++runs > 240) clearInterval(timer); /* two minutes is longer than any popup delay */
  }, 500);
  document.addEventListener('visibilitychange', tick);
})();

/* Klaviyo legacy popup/teaser guard. If their widget is in a fixed full-screen
   state, hide it immediately so the old intrusive 10% style never blocks the
   page even when the overlay is briefly visible before dismissal. */
(function () {
  var SELECTORS = [
    'div[class*="kl-private-reset-css"]',
    'div[id*="klaviyo"]',
    '[class*="klaviyo-embedded"]',
    '[class*="klaviyo-form"]',
    '[class*="klaviyo-teaser"]',
    '.klaviyo-form-teaser'
  ];

  function shouldHide(node) {
    if (!node || !(node instanceof Element)) return false;
    var cs = getComputedStyle(node);
    if (cs.position !== 'fixed' || cs.display === 'none' || cs.visibility === 'hidden') return false;
    var r = node.getBoundingClientRect();
    return r.width >= innerWidth * 0.85 && r.height >= innerHeight * 0.85;
  }

  function hide(node) { node.style.setProperty('display', 'none', 'important'); }

  function scan() {
    for (var s = 0; s < SELECTORS.length; s++) {
      var nodes = document.querySelectorAll(SELECTORS[s]);
      for (var i = 0; i < nodes.length; i++) {
        if (shouldHide(nodes[i])) hide(nodes[i]);
      }
    }
  }

  scan();
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
})();

/* Rail peek handle. The floating rail is fixed at the right edge on the
   vertical centre line, and mobile content runs nearly edge-to-edge, so a
   52px tile sits on top of whatever scrolls under it — measured on live,
   31 card hearts and 31 add-buttons on a single collection page. The rail
   therefore idles as a 24px handle (CSS in assets/sz-rd.css) and this opens
   it on demand.

   One tap, one action (owner ruling 2026-08-18, reversing the 2026-08-14
   two-tap design): the swallowed first tap made the rail "hard to click" — a
   24px handle that needs TWO taps with nothing saying so reads as a broken
   button. A tap on a handle now passes straight through to the widget, and
   opening the rail is cosmetic feedback around it. The accidental-graze
   protection the swallow bought is retired with it: a scroll gesture never
   fires click, and every widget on the rail is one tap to dismiss.
   Paired with the .sz-rail-open rules in assets/sz-rd.css. */
(function () {
  var RAIL = '#appstle-loyalty-button, .sz-concierge-launcher, .jdgm-revs-tab-btn, .sz-rd-themetab';
  var OPEN = 'sz-rail-open';
  var IDLE_MS = 6000;
  var root = document.documentElement;
  var mq = window.matchMedia('(max-width: 767px)');
  var timer;

  function close() {
    clearTimeout(timer);
    root.classList.remove(OPEN);
  }
  function open() {
    clearTimeout(timer);
    root.classList.add(OPEN);
    // Re-collapse on its own, so a stray tap does not leave the rail sitting
    // over the grid for the rest of the session.
    timer = setTimeout(close, IDLE_MS);
  }
  function inRail(t) {
    return !!(t && t.closest && t.closest(RAIL));
  }

  document.addEventListener(
    'click',
    function (e) {
      if (!mq.matches) return close();
      if (!inRail(e.target)) return close();
      open(); // expand + reset the idle timer; the tap ALSO reaches the widget
    },
    true
  );

  // Keyboard only. A pointer tap focuses the button BEFORE it clicks it, so an
  // unqualified focusin here opens the rail first and the click handler above
  // then sees it already open and lets the tap through to the widget — which
  // is exactly the swallow this is supposed to guarantee. :focus-visible is
  // the distinction between "focused" and "focused by keyboard".
  document.addEventListener('focusin', function (e) {
    if (!mq.matches || !inRail(e.target)) return;
    try {
      if (!e.target.matches(':focus-visible')) return;
    } catch (err) {
      return;
    }
    open();
  });

  // Scrolling is exactly when the rail is in the way, so get out of it.
  window.addEventListener('scroll', function () { if (root.classList.contains(OPEN)) close(); }, { passive: true });
})();

/* ==========================================================================
   sz-rd.js — behaviour for the redesign preview (layout/sz-redesign.liquid).

   Loaded ONLY by the sz-redesign layout, never by theme.liquid. House rules
   apply (GOTCHAS #11): document-level event delegation, nothing hidden
   before JS runs, every animation no-ops under prefers-reduced-motion,
   no CDNs. The redesign layout is plain MPA (no sz-transition.js), so this
   runs once per full page load.

   Owns:
   1. live cart badge  — server renders {{ cart.item_count }}; we re-sync from
      /cart.js on load (bfcache restores included) and after every add
   2. add-to-cart      — [data-sz-rd-add] posts its variant to /cart/add.js;
      the handoff designs count-feedback only (no cart drawer)
   3. hero carousel    — [data-sz-rd-hero]; static with one slide
   4. mobile hamburger — [data-sz-rd-burger] toggles the slide-down menu
   5. listing engine   — category / care / max-price / in-stock filters,
      chips, sort, counts, empty state; all client-side over the fully
      rendered grid (same architecture as the live facet panel)
   6. scroll-row dots  — decorative position dots under mobile card rows

   Wishlist hearts are NOT here — the cards emit the same [data-sz-wishlist]
   buttons the live theme uses and assets/sz-wishlist.js (loaded by the
   redesign layout too) owns that state, so saves are shared between the
   redesign preview and the live storefront (localStorage sz:wishlist:v1).
   ========================================================================== */

(() => {
  'use strict';

  const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. cart badge ---------- */

  const paintCartCount = (n) => {
    document.querySelectorAll('[data-sz-rd-cart-count]').forEach((el) => {
      el.textContent = n;
      if (n > 0) el.removeAttribute('data-empty');
      else el.setAttribute('data-empty', '');
    });
  };

  /* Free-shipping progress bar (snippets/sz-rd-announce.liquid). Server
     renders the initial state; this repaints it from the SAME /cart.js the
     badge uses — no second request, no polling. Threshold comes from the
     custom.free_shipping shop metafield via the snippet's data attribute, so
     the number lives in exactly one place. */
  const money = (cents) => {
    const dollars = cents / 100;
    return `$${dollars % 1 === 0 ? dollars.toFixed(0) : dollars.toFixed(2)}`;
  };

  const paintFreeShipping = (cart) => {
    const bar = document.querySelector('[data-sz-rd-announce]');
    if (!bar) return;
    const threshold = Number(bar.dataset.threshold) || 0;
    if (threshold <= 0) return;
    const total = cart ? cart.total_price : 0;
    const remaining = Math.max(0, threshold - total);
    const pct = Math.min(100, Math.round((total / threshold) * 100));

    const msg = bar.querySelector('[data-sz-rd-announce-msg]');
    const meterLabel = bar.querySelector('[data-sz-rd-announce-meter-label]');
    if (msg) {
      // Unqualified: free shipping is an automatic order-level discount now,
      // not a per-profile rate, so the whole cart total is the honest measure.
      if (!cart || !cart.item_count) msg.textContent = `Free shipping on orders over ${money(threshold)}`;
      else if (remaining > 0) msg.textContent = `Spend ${money(remaining)} more for free shipping`;
      else msg.textContent = 'Free shipping on this order.';
    }
    if (meterLabel) meterLabel.textContent = `${pct}%`;
    const fill = bar.querySelector('[data-sz-rd-announce-fill]');
    // Transform, not width — see .sz-rd-announce__fill in sz-rd.css.
    if (fill) fill.style.setProperty('--sz-rd-progress', String(pct / 100));
    const track = bar.querySelector('[data-sz-rd-announce-track]');
    if (track) track.setAttribute('aria-valuenow', String(pct));
    // CARD-REFINE-01: the meter only shows once there is something in the bag (an empty bag read "0%").
    bar.toggleAttribute('data-empty', !cart || !cart.item_count);
    // QUICK-FIX 2026-10-09: the band's own flag follows the bag too (phones show the meter row, tablets and narrow desktops pick the short note).
    const band = bar.closest('.sz-rd-announce-band');
    if (band) band.toggleAttribute('data-cart-empty', !cart || !cart.item_count);
    if (remaining <= 0 && cart && cart.item_count) bar.setAttribute('data-unlocked', '');
    else bar.removeAttribute('data-unlocked');
  };

  const syncCart = () => {
    fetch('/cart.js')
      .then((r) => (r.ok ? r.json() : null))
      .then((cart) => {
        if (!cart) return;
        paintCartCount(cart.item_count);
        paintFreeShipping(cart);
      })
      .catch(() => {}); /* badge + bar keep their server-rendered values */
  };

  // pageshow fires on bfcache restores too, where the server-rendered count
  // can be stale after a checkout/cart edit in another tab.
  window.addEventListener('pageshow', syncCart);
  // the in-cart module (end of file) repaints the badge + bar through this after a line change
  window.szRdSyncCart = syncCart;

  /* ---------- 2. add to cart ---------- */

  let adding = false;

  // The shared add routine. Reached two ways now:
  //   · click  — collection/card buttons, which are NOT inside a form
  //   · submit — the PDP, which gained a real <form> on 2026-08-15 so that
  //              purchase-option apps can hook it (GOTCHAS #70)
  // Anything inside a form is handled by the submit path ONLY, or a click
  // would add once and the submit would add again.
  // Build the add payload from the WHOLE form, not from a hand-picked set of
  // fields. Restock Rocket injects its own inputs once it finds the product
  // form — measured on live 2026-08-15:
  //   properties[Shipping]              "Sep 2, 2026"
  //   properties[Reserve now, pay later] "Pay 50% now and the remaining will…"
  //   properties[Pre-order]             "Save 0.00 AUD, ships on Sep 2, 2026"
  //   selling_plan                      (its own copy, alongside ours)
  // A hand-built {id, quantity, selling_plan} payload silently DROPS all of it,
  // so the order would lose its ship date and its record of the deposit terms.
  // form_type/utf8 are for the non-JS /cart/add endpoint and are not sent to
  // /cart/add.js.
  const payloadFromForm = (form) => {
    const out = { properties: {} };
    const attributes = {};
    new FormData(form).forEach((value, key) => {
      if (key === 'form_type' || key === 'utf8') return;
      const prop = key.match(/^properties\[(.+)\]$/);
      if (prop) { out.properties[prop[1]] = value; return; }
      // CART attributes, not line-item properties. STOQ injects one into this
      // form (`attributes[__stoq_data_<variant>]`, measured on live 2026-08-15).
      // /cart/add.js has no `attributes` field — cart attributes are set via
      // /cart/update.js — so passing the raw bracketed key through would send a
      // meaningless field. Collected here and applied after the add, which is
      // what a NATIVE form post to /cart/add does, keeping the two paths equal.
      const attr = key.match(/^attributes\[(.+)\]$/);
      if (attr) { attributes[attr[1]] = value; return; }
      out[key] = value;
    });
    if (!Object.keys(out.properties).length) delete out.properties;
    if (Object.keys(attributes).length) out.__attributes = attributes;
    return out;
  };

  const addToCart = (btn) => {
    // `adding` is released when the cart round-trip finishes, which is ~1s. A
    // second deliberate click after that is a legitimate second add and must
    // still work — this guard is only against a burst, not against buying more.
    if (adding) return;
    const id = Number(btn.dataset.variantId);
    if (!id) return;
    const form = btn.closest('form[data-sz-rd-form]');
    // Consent gate. Checked BEFORE `adding` is set, so a refusal does not leave
    // the flag stuck and block every later attempt. Only enforced when the
    // block is actually shown — it is hidden for variants with no deposit.
    if (form) {
      const consentWrap = form.querySelector('[data-sz-rd-consent]');
      const consentBox = form.querySelector('[data-sz-rd-consent-box]');
      if (consentWrap && !consentWrap.hidden && consentBox && !consentBox.checked) {
        // Say why rather than silently doing nothing — the app's version just
        // greys the button out, which reads as "broken" (it did to us for an
        // entire session).
        consentWrap.classList.add('is-required');
        consentBox.focus();
        return;
      }
    }
    adding = true;
    /* Feedback at 0ms, not at ~1s. The add is a 2-4 request chain and the
       button previously showed NOTHING until the whole thing settled — which
       reads as "slow" (owner, 2026-08-23) or worse, as "didn't work", inviting
       the double-click the `adding` guard exists for. The class is CSS-only:
       a spinner ring over the existing content, never touching textContent
       (the inline Lucide SVGs live there). */
    btn.classList.add('is-adding');
    btn.setAttribute('aria-busy', 'true');
    // PDP add buttons respect the quantity stepper; card buttons always add 1
    let quantity = 1;
    const pdpRoot = btn.closest('[data-sz-rd-pdp]');
    if (pdpRoot) {
      const qtyEl = pdpRoot.querySelector('[data-sz-rd-qty]');
      if (qtyEl) quantity = Math.min(99, Math.max(1, parseInt(qtyEl.value, 10) || 1));
    }
    // A pre-order deposit is a SELLING PLAN, and /cart/add.js only applies one
    // when the request carries `selling_plan`. Without it Shopify charges the
    // full amount no matter what the button says — measured 2026-08-14, when a
    // pre-order relabelled "PRE-ORDER" still checked out at 100%. The attribute
    // is rendered only when the variant actually has a plan, so this stays a
    // no-op until one exists.
    const payload = form ? payloadFromForm(form) : { id, quantity };
    // The stepper is the source of truth for quantity, and the variant id is
    // re-synced onto both the button and the hidden field by paintVariant —
    // these two are asserted rather than trusted from the serialisation.
    payload.id = id;
    payload.quantity = quantity;
    // The BUTTON is authoritative for the plan — paintVariant maintains it.
    // The delete is not defensive tidying: third-party apps inject their OWN
    // `selling_plan` input, and serialising the form picks it up even after
    // ours has been removed for a plan-less variant. Without this, switching
    // from a pre-order grade to an in-stock one adds the in-stock item WITH a
    // deposit plan attached. Caught by the prover 2026-08-15.
    const plan = Number(btn.dataset.sellingPlan);
    if (plan) payload.selling_plan = plan;
    else delete payload.selling_plan;
    // Lifted off the payload — see payloadFromForm. Applied after the add.
    const cartAttributes = payload.__attributes;
    delete payload.__attributes;

    // ── Merge into an existing line rather than creating a second one ───────
    // Owner report 2026-08-17: adding the same product again produced a SECOND
    // cart line — 10 × Bloody Mary at $72.00 and another 10 at $90.00, only one
    // of them discounted. Shopify merges two adds only when variant, selling
    // plan AND every line property match exactly. Several apps write into this
    // form and re-render it after a cart change, so the second payload is not
    // reliably identical to the first — and if the line that differs is the one
    // WITHOUT the selling plan, that line is charged in full.
    //
    // Rather than chase payload parity across apps we cannot control, look for a
    // line with the same variant and the same plan and bump its quantity. One
    // line per variant+plan, whatever the apps do to the properties in between.
    // Round trips ARE the latency (owner 2026-09-08: "add to cart is a little slow" -
    // measured 1.7s: read cart, add, read cart). A plain in-stock add needs no merge
    // check, Shopify merges identical plain lines itself, so it goes straight to
    // /cart/add.js. Only a selling-plan (deposit) line takes the merge path.
    const plainAdd = () => fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    });
    const mergeOrAdd = () => !payload.selling_plan ? plainAdd() : (
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then((r) => (r.ok ? r.json() : null))
        .then((cart) => {
          const wantPlan = payload.selling_plan ? Number(payload.selling_plan) : null;
          const idx = cart
            ? cart.items.findIndex((li) => {
                const linePlan = li.selling_plan_allocation
                  ? Number(li.selling_plan_allocation.selling_plan.id)
                  : null;
                return Number(li.variant_id) === Number(payload.id) && linePlan === wantPlan;
              })
            : -1;
          if (idx < 0) {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify(payload),
            });
          }
          // /cart/change.js keeps the existing line's properties intact, which
          // is what makes this a merge rather than a replace. Its response body
          // is the FULL cart, so the merge path needs no follow-up /cart.js.
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            // JS-BAG-1014: by line KEY, not position — a stock trim running at the same time can shift positions.
            body: JSON.stringify({
              id: cart.items[idx].key,
              quantity: cart.items[idx].quantity + Number(payload.quantity || 1),
            }),
          }).then((r) => {
            if (r.ok) r.__isFullCart = true;
            return r;
          });
        }));

    mergeOrAdd()
      .then((r) => {
        if (!r.ok) throw new Error('add failed');
        // "Added" the moment Shopify says yes; the count + bar repaint follows.
        btn.classList.add('is-added');
        btn.classList.remove('is-adding');
        btn.removeAttribute('aria-busy');
        btn.dispatchEvent(new CustomEvent('sz-rd:added', { bubbles: true }));
        // Cart attributes go in a separate call; a native form post would have
        // set them as part of the same submit. Failure here must NOT fail the
        // add — the item is already in the cart and an app's tracking blob is
        // not worth showing the customer an error over.
        //
        // Round trips are the whole latency story here (owner, 2026-08-23), so
        // no request is spent re-asking what a response already said:
        // /cart/change.js and /cart/update.js both RETURN the full cart, so
        // only the plain /cart/add.js path (which returns just the added line)
        // still needs a /cart.js read for the count + free-shipping repaint.
        if (cartAttributes) {
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: cartAttributes }),
          })
            .then((u) => (u.ok ? u.json() : fetch('/cart.js').then((c) => c.json())))
            .catch(() => fetch('/cart.js').then((c) => c.json()));
        }
        if (r.__isFullCart) return r.json();
        return fetch('/cart.js').then((c) => c.json());
      })
      .then((cart) => {
        paintCartCount(cart.item_count);
        // The add just changed the cart total, so the free-shipping bar is
        // stale until this runs — it is the moment the progress is most
        // worth seeing move.
        paintFreeShipping(cart);
        // feedback is CSS-only: .is-added swaps the idle/done spans the card
        // renders (never rewrite textContent — the inline Lucide SVGs live there)
        btn.classList.add('is-added');
        setTimeout(() => btn.classList.remove('is-added'), 1600);
      })
      .catch(() => {
        // Sold out mid-session, price $0 blocked, etc. — fall through to the
        // PDP where the full purchase UI (back-in-stock notify included) lives.
        const url = btn.dataset.productUrl;
        if (url) window.location.href = url;
      })
      .finally(() => {
        adding = false;
        btn.classList.remove('is-adding');
        btn.removeAttribute('aria-busy');
      });
  };

  document.addEventListener(
    'click',
    (e) => {
      const btn = e.target.closest && e.target.closest('[data-sz-rd-add]');
      if (!btn) return;
      const form = btn.closest('form[data-sz-rd-form]');
      if (!form) {
        // Collection cards: no form, plain click handling.
        e.preventDefault();
        addToCart(btn);
        return;
      }
      // ── PDP: WE own this click, exclusively ──────────────────────────────
      // Owner report 2026-08-16: clicking add twice produced TWO CART LINES for
      // one variant — $72.00 discounted and $90.00 not. Shopify only splits a
      // line when the payloads differ, so two different adds were firing with
      // different bodies.
      //
      // A click on a type=submit button fires CLICK first, then SUBMIT. Any
      // third-party click handler on our button therefore gets to add before
      // our submit handler does, with its own payload — and a pre-order PDP now
      // has several apps bound to this exact button.
      //
      // Capture phase + stopImmediatePropagation is the only ordering we can
      // actually guarantee: capture runs before every bubble listener no matter
      // who registered first. preventDefault also stops the native submit, so
      // the submit handler below never double-fires either.
      e.preventDefault();
      e.stopImmediatePropagation();
      addToCart(btn);
    },
    true // capture
  );

  // PDP form. preventDefault keeps the fetch-based UX (no page reload, the
  // "Added" state, the cart badge repaint); without JS the form posts to
  // /cart/add natively, which is the point of it existing at all.
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!form || !form.matches || !form.matches('[data-sz-rd-form]')) return;
    const btn = form.querySelector('[data-sz-rd-add]');
    if (!btn) return;
    e.preventDefault();
    addToCart(btn);
  });

  /* ---------- 3. hero carousel ---------- */

  document.querySelectorAll('[data-sz-rd-hero]').forEach((hero) => {
    const slides = hero.querySelectorAll('[data-sz-rd-slide]');
    const dots = hero.querySelectorAll('[data-sz-rd-dot]');
    if (slides.length < 2) return; // single designed slide ships static
    let i = 0;
    let timer = null;
    const show = (n) => {
      i = (n + slides.length) % slides.length;
      slides.forEach((s, k) => s.classList.toggle('is-active', k === i));
      dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
    };
    const auto = () => {
      if (REDUCED) return;
      clearInterval(timer);
      timer = setInterval(() => show(i + 1), 6000);
    };
    dots.forEach((d, k) => d.addEventListener('click', () => { show(k); auto(); }));
    hero.addEventListener('pointerenter', () => clearInterval(timer));
    hero.addEventListener('pointerleave', auto);
    auto();
  });

  /* ---------- 4. mobile hamburger ---------- */

  document.addEventListener('click', (e) => {
    const burger = e.target.closest && e.target.closest('[data-sz-rd-burger]');
    if (burger) {
      const open = document.body.classList.toggle('sz-rd-menu-open');
      burger.setAttribute('aria-expanded', String(open));
      return;
    }
    // tapping a menu link closes the panel (full page nav follows anyway;
    // this just avoids a flash of open menu on bfcache back)
    if (e.target.closest && e.target.closest('[data-sz-rd-menu] a')) {
      document.body.classList.remove('sz-rd-menu-open');
      burger && burger.setAttribute('aria-expanded', 'false');
    }
  });

  /* ---------- 5. listing engine ---------- */

  const listing = document.querySelector('[data-sz-rd-listing]');
  if (listing) {
    const grid = listing.querySelector('[data-sz-rd-grid]');
    const items = Array.from(grid.querySelectorAll('[data-sz-rd-item]'));
    items.forEach((el, k) => { el.dataset.szRdIndex = k; });

    const catsBox = listing.querySelector('[data-sz-rd-cats]');
    const chipsBox = listing.querySelector('[data-sz-rd-chips]');
    const sortSel = listing.querySelector('[data-sz-rd-sort]');
    const priceEl = listing.querySelector('[data-sz-rd-price]');
    const priceLabel = listing.querySelector('[data-sz-rd-price-label]');
    const priceMinEl = listing.querySelector('[data-sz-rd-price-min]');
    const priceMaxEl = listing.querySelector('[data-sz-rd-price-max]');
    const stockBtn = listing.querySelector('[data-sz-rd-stock]');
    const countEl = listing.querySelector('[data-sz-rd-count]');
    const emptyEl = listing.querySelector('[data-sz-rd-empty]');
    const titleEl = listing.querySelector('[data-sz-rd-title]');
    const crumbEl = listing.querySelector('[data-sz-rd-crumb]');
    const defaultTitle = titleEl ? titleEl.textContent.trim() : '';

    const money = (n) => '$' + n.toFixed(2).replace(/\.00$/, '');

    // price bounds from the real catalogue (design's fixed $2–$15 assumed the
    // prototype's sample data; the live spread runs to $100+ graded variants)
    const prices = items.map((el) => parseFloat(el.dataset.price) || 0);
    const lo = prices.length ? Math.min.apply(null, prices) : 0;
    const hi = prices.length ? Math.max.apply(null, prices) : 1;
    const bounds = { min: Math.floor(lo), max: Math.max(1, Math.ceil(hi)) };
    if (priceEl) {
      priceEl.min = String(bounds.min);
      priceEl.max = String(bounds.max);
      priceEl.step = '1';
      priceEl.value = String(bounds.max);
      if (priceMinEl) priceMinEl.textContent = money(bounds.min);
      if (priceMaxEl) priceMaxEl.textContent = money(bounds.max);
    }

    // categories derived from the rendered cards (szn.species_group), so
    // Plants/Fish/etc appear automatically once such products exist
    const catCounts = {};
    items.forEach((el) => {
      const c = el.dataset.cat || 'Other';
      catCounts[c] = (catCounts[c] || 0) + 1;
    });
    const catNames = ['All'].concat(Object.keys(catCounts));

    // colours derived the same way, from szn.colors on each card. A shrimp can
    // carry several (blue + orange), so this is many-to-many: selecting "blue"
    // matches anything WITH blue in it, not just primary-blue lines.
    const colorCard = listing.querySelector('[data-sz-rd-colorcard]');
    const colorsBox = listing.querySelector('[data-sz-rd-colors]');
    const cardColors = (el) => (el.dataset.colors || '').split('|').filter(Boolean);
    const colorCounts = {};
    items.forEach((el) => {
      cardColors(el).forEach((c) => { colorCounts[c] = (colorCounts[c] || 0) + 1; });
    });
    // most-stocked first, so the useful colours sit at the top of the list
    const colorNames = Object.keys(colorCounts).sort(
      (a, b) => colorCounts[b] - colorCounts[a] || a.localeCompare(b)
    );
    // dot fills encode the ANIMAL's colour (content), not the brand palette.
    // "metallic" is a FINISH, not a hue (owner: all Boas, the orange/red/purple
    // Galaxy Tigers and Metallic Black Snowflake) — it gets a sheen gradient so
    // it reads as a surface quality rather than pretending to be a colour.
    const COLOR_DOTS = {
      red: '#b4342e', orange: '#c96a2a', yellow: '#d4a72c', green: '#4f8f5a',
      blue: '#2f6fb0', purple: '#6b5194', pink: '#c9738a', brown: '#7a5540',
      black: '#191d1a', white: '#e4e9e2',
      metallic: 'linear-gradient(135deg,#8c9aa2 0%,#e8eef0 38%,#7f8d95 62%,#c3ced4 100%)',
    };
    const titleCase = (s) => s.charAt(0).toUpperCase() + s.slice(1);

    // line families, same data-driven rule (szn.line_family on each card).
    // Single-valued per product, unlike colours. Handleized keys so the genus
    // intro's ?family=taiwan-bee deep-link matches "Taiwan Bee" exactly.
    const familyCard = listing.querySelector('[data-sz-rd-familycard]');
    const familiesBox = listing.querySelector('[data-sz-rd-families]');
    const handleize = (s) => String(s).toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    const familyCounts = {};
    items.forEach((el) => {
      const f = (el.dataset.family || '').trim();
      if (f) familyCounts[f] = (familyCounts[f] || 0) + 1;
    });
    const familyNames = Object.keys(familyCounts).sort(
      (a, b) => familyCounts[b] - familyCounts[a] || a.localeCompare(b)
    );

    // eye genetics — same derivation as line families
    const eyeCard = listing.querySelector('[data-sz-rd-eyecard]');
    const eyesBox = listing.querySelector('[data-sz-rd-eyes]');
    const eyeCounts = {};
    items.forEach((el) => {
      const e = (el.dataset.eye || '').trim();
      if (e) eyeCounts[e] = (eyeCounts[e] || 0) + 1;
    });
    const eyeNames = Object.keys(eyeCounts).sort(
      (a, b) => eyeCounts[b] - eyeCounts[a] || a.localeCompare(b)
    );

    // Supplies axes (owner 2026-08-13) — same derivation again:
    //   sub   = szn.product_subgroup, the menu sub-category ("Fertilisers")
    //   brand = product.vendor
    // Brand deliberately stays hidden while only ONE vendor is stocked: a
    // control that filters 47 of 47 is noise. It turns itself on at two.
    const subCard = listing.querySelector('[data-sz-rd-subcard]');
    const subsBox = listing.querySelector('[data-sz-rd-subs]');
    const brandCard = listing.querySelector('[data-sz-rd-brandcard]');
    const brandsBox = listing.querySelector('[data-sz-rd-brands]');
    const countBy = (attr) => {
      const out = {};
      items.forEach((el) => {
        const v = (el.dataset[attr] || '').trim();
        if (v) out[v] = (out[v] || 0) + 1;
      });
      return out;
    };
    const byCountThenName = (counts) => (a, b) => counts[b] - counts[a] || a.localeCompare(b);
    const subCounts = countBy('sub');
    const subNames = Object.keys(subCounts).sort(byCountThenName(subCounts));
    const brandCounts = countBy('brand');
    const brandNames = Object.keys(brandCounts).sort(byCountThenName(brandCounts));

    // Care level is livestock-only and now gated the same way, so the supplies
    // collection stops rendering an empty "Care level" panel (found 2026-08-13).
    const careCard = listing.querySelector('[data-sz-rd-carecard]');
    const careHave = countBy('care');
    if (careCard && Object.keys(careHave).length) {
      careCard.hidden = false;
      listing.querySelectorAll('[data-sz-rd-carerow]').forEach((row) => {
        if (careHave[row.getAttribute('data-sz-rd-carerow')]) row.hidden = false;
      });
    }

    const state = {
      cat: 'All',
      levels: [],
      colors: [],
      families: [],
      eyes: [],
      subs: [],
      brands: [],
      groups: [],
      maxPrice: bounds.max,
      inStock: false,
      sort: 'featured',
    };

    // URL presets — how tiles/nav deep-link into the filter engine:
    //   ?cat=<category>  ?max=<price ceiling, dollars>  (homepage "Starter
    //   shrimp" tile links ?max=18 — owner spec 2026-08-11). Presets set
    //   state BEFORE the initial apply(), so chips/label/slider all render.
    const params = new URLSearchParams(window.location.search);
    const catParam = params.get('cat');
    if (catParam) {
      const hit = catNames.find((c) => c.toLowerCase() === catParam.toLowerCase());
      if (hit) state.cat = hit;
    }
    const maxParam = parseFloat(params.get('max'));
    if (Number.isFinite(maxParam) && maxParam >= bounds.min && maxParam < bounds.max) {
      state.maxPrice = maxParam;
      if (priceEl) priceEl.value = String(maxParam);
    }
    // ?colour=blue (or ?color=, or a comma list) — this is what stands in for
    // per-colour landing pages: /collections/caridina?colour=blue is a real,
    // linkable, shareable "blue Caridina" view. Unknown colours are ignored so
    // a stale link degrades to the unfiltered collection rather than an empty one.
    const colourParam = params.get('colour') || params.get('color');
    if (colourParam) {
      state.colors = colourParam
        .split(',')
        .map((c) => c.trim().toLowerCase())
        .filter((c) => colorNames.indexOf(c) !== -1);
    }
    // ?family=taiwan-bee — what the genus-intro family cards link to. Matched on
    // the handleized name so "Fancy Tiger" ↔ fancy-tiger. Unknown values are
    // dropped so a stale link degrades to the full collection, never an empty one.
    const familyParam = params.get('family');
    if (familyParam) {
      const wanted = familyParam.split(',').map((f) => handleize(f));
      state.families = familyNames.filter((f) => wanted.indexOf(handleize(f)) !== -1);
    }
    // ?group=aquascaping — what the supplies intro's category cards link
    // to, and ?sub=fertilisers for a direct sub-category link. Same handleized
    // matching and same degrade-to-full-collection rule as family/eye above.
    // data-group is pipe-delimited like data-colors: szn.product_groups is a
    // LIST, because a dual-purpose product sits in both care groups.
    const cardGroups = (el) => (el.dataset.group || '').split('|').filter(Boolean);
    const groupParam = params.get('group');
    if (groupParam) {
      const wantedG = groupParam.split(',').map((g) => handleize(g));
      const allGroups = {};
      items.forEach((el) => {
        cardGroups(el).forEach((g) => { allGroups[g] = true; });
      });
      state.groups = Object.keys(allGroups).filter((g) => wantedG.indexOf(handleize(g)) !== -1);
    }
    const subParam = params.get('sub');
    if (subParam) {
      const wantedS = subParam.split(',').map((x) => handleize(x));
      state.subs = subNames.filter((x) => wantedS.indexOf(handleize(x)) !== -1);
    }
    // ?eye=golden-eye-ghost — what the Neocaridina intro tiles link to
    const eyeParam = params.get('eye');
    if (eyeParam) {
      const wantedEyes = eyeParam.split(',').map((e) => handleize(e));
      state.eyes = eyeNames.filter((e) => wantedEyes.indexOf(handleize(e)) !== -1);
    }
    // ?care=Beginner — the Sulawesi dropdown splits by difficulty, which is the
    // organising axis for that genus. The care boxes are static markup, so tick
    // them here; apply() does not own them the way it owns the derived rows.
    const careParam = params.get('care');
    if (careParam) {
      const wantedCare = careParam.split(',').map((c) => c.trim().toLowerCase());
      state.levels = ['Beginner', 'Intermediate', 'Advanced']
        .filter((l) => wantedCare.indexOf(l.toLowerCase()) !== -1);
      state.levels.forEach((l) => {
        const box = listing.querySelector('[data-sz-rd-care][value="' + l + '"]');
        if (box) box.checked = true;
      });
    }

    // hide care-level checkboxes no product carries (e.g. pre-plants catalogue)
    const careCounts = {};
    items.forEach((el) => {
      const c = el.dataset.care;
      if (c) careCounts[c] = (careCounts[c] || 0) + 1;
    });
    listing.querySelectorAll('[data-sz-rd-care]').forEach((box) => {
      if (!careCounts[box.value]) box.closest('.sz-rd-check').hidden = true;
    });

    const renderCats = () => {
      catsBox.innerHTML = '';
      catNames.forEach((name) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'sz-rd-catlist__row' + (state.cat === name ? ' is-active' : '');
        const label = document.createElement('span');
        label.textContent = name;
        const n = document.createElement('span');
        n.className = 'n';
        n.textContent = name === 'All' ? items.length : catCounts[name];
        b.append(label, n);
        b.addEventListener('click', () => { state.cat = name; apply(); });
        catsBox.appendChild(b);
      });
    };

    // static markup, safe for innerHTML — lucide "x", matches snippets/sz-rd-icon.liquid
    const X_SVG = '<svg xmlns="http://www.w3.org/2000/svg" class="sz-rd-i" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>';
    // lucide "check" — same source as {% render 'sz-rd-icon', icon: 'check' %}
    const CHECK_SVG = '<svg xmlns="http://www.w3.org/2000/svg" class="sz-rd-i" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M20 6 9 17l-5-5"/></svg>';

    // colour rows mirror the care-level checkbox markup so the existing
    // .sz-rd-check styles apply; the swatch dot is the only new element
    const renderEyes = () => {
      if (!eyesBox || !eyeCard || !eyeNames.length) return;
      eyeCard.hidden = false;
      eyesBox.textContent = '';
      eyeNames.forEach((name) => {
        const label = document.createElement('label');
        label.className = 'sz-rd-check';
        const input = document.createElement('input');
        input.type = 'checkbox';
        input.setAttribute('data-sz-rd-eye', '');
        input.value = name;
        input.checked = state.eyes.indexOf(name) !== -1;
        const box = document.createElement('span');
        box.className = 'sz-rd-check__box';
        box.setAttribute('aria-hidden', 'true');
        box.innerHTML = CHECK_SVG;
        const text = document.createElement('span');
        text.textContent = name;
        const n = document.createElement('span');
        n.className = 'sz-rd-colorn';
        n.textContent = eyeCounts[name];
        label.append(input, box, text, n);
        eyesBox.appendChild(label);
      });
    };

    // line-family rows reuse the care-level checkbox markup, minus the swatch
    const renderFamilies = () => {
      if (!familiesBox || !familyCard) return;
      if (!familyNames.length) return;
      familyCard.hidden = false;
      familiesBox.textContent = '';
      familyNames.forEach((name) => {
        const label = document.createElement('label');
        label.className = 'sz-rd-check';

        const input = document.createElement('input');
        input.type = 'checkbox';
        input.setAttribute('data-sz-rd-family', '');
        input.value = name;
        input.checked = state.families.indexOf(name) !== -1;

        const box = document.createElement('span');
        box.className = 'sz-rd-check__box';
        box.setAttribute('aria-hidden', 'true');
        box.innerHTML = CHECK_SVG;

        const text = document.createElement('span');
        text.textContent = name;

        const n = document.createElement('span');
        n.className = 'sz-rd-colorn';
        n.textContent = familyCounts[name];

        label.append(input, box, text, n);
        familiesBox.appendChild(label);
      });
    };

    // Sub-category and brand rows are the family markup again, so one CSS rule
    // covers all four. minCount lets brand hide itself until there are two.
    const renderPicker = (box, card, names, counts, attr, key, minCount) => {
      if (!box || !card) return;
      if (names.length < (minCount || 1)) return;
      card.hidden = false;
      box.textContent = '';
      names.forEach((name) => {
        const label = document.createElement('label');
        label.className = 'sz-rd-check';

        const input = document.createElement('input');
        input.type = 'checkbox';
        input.setAttribute(attr, '');
        input.value = name;
        input.checked = state[key].indexOf(name) !== -1;

        const box2 = document.createElement('span');
        box2.className = 'sz-rd-check__box';
        box2.setAttribute('aria-hidden', 'true');
        box2.innerHTML = CHECK_SVG;

        const text = document.createElement('span');
        text.textContent = name;

        const n = document.createElement('span');
        n.className = 'sz-rd-colorn';
        n.textContent = counts[name];

        label.append(input, box2, text, n);
        box.appendChild(label);
      });
    };
    const renderSubs = () =>
      renderPicker(subsBox, subCard, subNames, subCounts, 'data-sz-rd-sub', 'subs', 1);
    const renderBrands = () =>
      renderPicker(brandsBox, brandCard, brandNames, brandCounts, 'data-sz-rd-brand', 'brands', 2);

    const renderColors = () => {
      if (!colorsBox || !colorCard) return;
      if (!colorNames.length) return;
      colorCard.hidden = false;
      colorsBox.textContent = '';
      colorNames.forEach((name) => {
        const label = document.createElement('label');
        label.className = 'sz-rd-check';

        const input = document.createElement('input');
        input.type = 'checkbox';
        input.setAttribute('data-sz-rd-color', '');
        input.value = name;
        input.checked = state.colors.indexOf(name) !== -1;

        const box = document.createElement('span');
        box.className = 'sz-rd-check__box';
        box.setAttribute('aria-hidden', 'true');
        box.innerHTML = CHECK_SVG;

        const dot = document.createElement('span');
        dot.className = 'sz-rd-colordot';
        dot.style.background = COLOR_DOTS[name] || 'var(--rd-mut-3)';

        const text = document.createElement('span');
        text.textContent = titleCase(name);

        const n = document.createElement('span');
        n.className = 'sz-rd-colorn';
        n.textContent = colorCounts[name];

        label.append(input, box, dot, text, n);
        colorsBox.appendChild(label);
      });
    };

    const chip = (label, onRemove) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'sz-rd-chip';
      const t = document.createElement('span');
      t.textContent = label;
      const x = document.createElement('span');
      x.className = 'x';
      x.innerHTML = X_SVG;
      b.append(t, x);
      b.setAttribute('aria-label', 'Remove filter: ' + label);
      b.addEventListener('click', onRemove);
      return b;
    };

    const renderChips = () => {
      chipsBox.innerHTML = '';
      state.levels.forEach((l) => {
        chipsBox.appendChild(chip(l, () => {
          state.levels = state.levels.filter((x) => x !== l);
          const box = listing.querySelector('[data-sz-rd-care][value="' + l + '"]');
          if (box) box.checked = false;
          apply();
        }));
      });
      if (state.maxPrice < bounds.max) {
        chipsBox.appendChild(chip('Under ' + money(state.maxPrice), () => {
          state.maxPrice = bounds.max;
          if (priceEl) priceEl.value = String(bounds.max);
          apply();
        }));
      }
      state.eyes.forEach((e) => {
        chipsBox.appendChild(chip(e, () => {
          state.eyes = state.eyes.filter((x) => x !== e);
          apply();
        }));
      });
      state.families.forEach((f) => {
        chipsBox.appendChild(chip(f, () => {
          state.families = state.families.filter((x) => x !== f);
          apply();
        }));
      });
      state.subs.forEach((sv) => {
        chipsBox.appendChild(chip(sv, () => {
          state.subs = state.subs.filter((x) => x !== sv);
          apply();
        }));
      });
      state.groups.forEach((gv) => {
        chipsBox.appendChild(chip(gv, () => {
          state.groups = state.groups.filter((x) => x !== gv);
          apply();
        }));
      });
      state.brands.forEach((bv) => {
        chipsBox.appendChild(chip(bv, () => {
          state.brands = state.brands.filter((x) => x !== bv);
          apply();
        }));
      });
      state.colors.forEach((c) => {
        chipsBox.appendChild(chip(titleCase(c), () => {
          state.colors = state.colors.filter((x) => x !== c);
          apply();
        }));
      });
      if (state.inStock) {
        chipsBox.appendChild(chip('In stock', () => { state.inStock = false; apply(); }));
      }
    };

    const apply = () => {
      let visible = items.filter((el) => {
        const okCat = state.cat === 'All' || (el.dataset.cat || 'Other') === state.cat;
        const okCare = state.levels.length === 0 || state.levels.indexOf(el.dataset.care) !== -1;
        // OR within colours (blue OR red), AND against every other filter —
        // the same logic Shopify's native storefront filtering uses
        const okColor = state.colors.length === 0
          || cardColors(el).some((c) => state.colors.indexOf(c) !== -1);
        const okFamily = state.families.length === 0
          || state.families.indexOf((el.dataset.family || '').trim()) !== -1;
        const okEye = state.eyes.length === 0
          || state.eyes.indexOf((el.dataset.eye || '').trim()) !== -1;
        const okSub = state.subs.length === 0
          || state.subs.indexOf((el.dataset.sub || '').trim()) !== -1;
        const okBrand = state.brands.length === 0
          || state.brands.indexOf((el.dataset.brand || '').trim()) !== -1;
        const okGroup = state.groups.length === 0
          || cardGroups(el).some((g) => state.groups.indexOf(g) !== -1);
        const okPrice = (parseFloat(el.dataset.price) || 0) <= state.maxPrice;
        const okStock = !state.inStock || el.dataset.stock === 'in';
        return okCat && okCare && okColor && okFamily && okEye
          && okSub && okBrand && okGroup && okPrice && okStock;
      });

      const by = {
        'price-asc': (a, b) => (parseFloat(a.dataset.price) || 0) - (parseFloat(b.dataset.price) || 0),
        'price-desc': (a, b) => (parseFloat(b.dataset.price) || 0) - (parseFloat(a.dataset.price) || 0),
        rating: (a, b) => (parseFloat(b.dataset.rating) || 0) - (parseFloat(a.dataset.rating) || 0),
        featured: (a, b) => Number(a.dataset.szRdIndex) - Number(b.dataset.szRdIndex),
      };
      visible = visible.slice().sort(by[state.sort] || by.featured);

      items.forEach((el) => { el.hidden = true; });
      visible.forEach((el) => { el.hidden = false; grid.appendChild(el); });

      if (countEl) countEl.textContent = visible.length;
      if (emptyEl) emptyEl.hidden = visible.length !== 0;
      if (priceLabel) priceLabel.textContent = 'Up to ' + money(state.maxPrice);
      if (stockBtn) stockBtn.setAttribute('aria-pressed', String(state.inStock));
      if (titleEl) titleEl.textContent = state.cat === 'All' ? defaultTitle : state.cat.toUpperCase();
      if (crumbEl) crumbEl.textContent = state.cat === 'All' ? (crumbEl.dataset.default || 'Shop') : state.cat;
      renderCats();
      renderFamilies();
      renderEyes();
      renderSubs();
      renderBrands();
      renderColors();
      renderChips();
    };

    listing.addEventListener('change', (e) => {
      const care = e.target.closest && e.target.closest('[data-sz-rd-care]');
      if (care) {
        state.levels = care.checked
          ? state.levels.concat([care.value])
          : state.levels.filter((x) => x !== care.value);
        apply();
      }
      const colour = e.target.closest && e.target.closest('[data-sz-rd-color]');
      if (colour) {
        state.colors = colour.checked
          ? state.colors.concat([colour.value])
          : state.colors.filter((x) => x !== colour.value);
        apply();
      }
      const eye = e.target.closest && e.target.closest('[data-sz-rd-eye]');
      if (eye) {
        state.eyes = eye.checked
          ? state.eyes.concat([eye.value])
          : state.eyes.filter((x) => x !== eye.value);
        apply();
      }
      const family = e.target.closest && e.target.closest('[data-sz-rd-family]');
      if (family) {
        state.families = family.checked
          ? state.families.concat([family.value])
          : state.families.filter((x) => x !== family.value);
        apply();
      }
      const sub = e.target.closest && e.target.closest('[data-sz-rd-sub]');
      if (sub) {
        state.subs = sub.checked
          ? state.subs.concat([sub.value])
          : state.subs.filter((x) => x !== sub.value);
        apply();
      }
      const brand = e.target.closest && e.target.closest('[data-sz-rd-brand]');
      if (brand) {
        state.brands = brand.checked
          ? state.brands.concat([brand.value])
          : state.brands.filter((x) => x !== brand.value);
        apply();
      }
    });
    if (priceEl) {
      priceEl.addEventListener('input', () => {
        state.maxPrice = parseFloat(priceEl.value);
        apply();
      });
    }
    if (stockBtn) stockBtn.addEventListener('click', () => { state.inStock = !state.inStock; apply(); });
    if (sortSel) sortSel.addEventListener('change', () => { state.sort = sortSel.value; apply(); });
    listing.querySelectorAll('[data-sz-rd-clear]').forEach((b) => {
      b.addEventListener('click', () => {
        state.cat = 'All';
        state.levels = [];
        state.colors = [];
        state.families = [];
        state.eyes = [];
        state.subs = [];
        state.brands = [];
        state.groups = [];
        state.maxPrice = bounds.max;
        state.inStock = false;
        state.sort = 'featured';
        listing.querySelectorAll('[data-sz-rd-care]').forEach((c) => { c.checked = false; });
        listing.querySelectorAll('[data-sz-rd-color]').forEach((c) => { c.checked = false; });
        listing.querySelectorAll('[data-sz-rd-family]').forEach((c) => { c.checked = false; });
        listing.querySelectorAll('[data-sz-rd-sub]').forEach((c) => { c.checked = false; });
        listing.querySelectorAll('[data-sz-rd-brand]').forEach((c) => { c.checked = false; });
        listing.querySelectorAll('[data-sz-rd-eye]').forEach((c) => { c.checked = false; });
        if (priceEl) priceEl.value = String(bounds.max);
        if (sortSel) sortSel.value = 'featured';
        apply();
      });
    });

    apply();
  }

  /* ---------- 5b. PDP: variants, gallery, quantity ---------- */

  const pdp = document.querySelector('[data-sz-rd-pdp]');
  if (pdp) {
    const money = (cents) => '$' + (cents / 100).toFixed(2);
    let variants = [];
    const dataEl = pdp.querySelector('[data-sz-rd-variants]');
    try { variants = dataEl ? JSON.parse(dataEl.textContent) : []; } catch { variants = []; }

    const groups = Array.from(pdp.querySelectorAll('[data-sz-rd-opt]'));
    const addBtn = pdp.querySelector('[data-sz-rd-add]');

    /* Take the button back from third-party purchase apps. STOQ's product
     * script (extension asset still named restockrocket-product.js — same
     * vendor, app renamed) tags any selling-plan button and disables it
     * while it resolves its offer; plan 697748390200 is an ORPHAN it does
     * not own, so the lookup never resolves and the disable never lifts —
     * measured live 2026-08-27: pre-order buttons unclickable. This form is
     * OURS (2026-08-15 decision, GOTCHAS #70): availability is decided by
     * data-sz-rd-state (server-rendered, re-painted on variant change), and
     * any other script disabling a buyable button is reversed on the spot. */
    if (addBtn) {
      new MutationObserver(() => {
        if (addBtn.disabled && addBtn.dataset.szRdState !== 'out') addBtn.disabled = false;
      }).observe(addBtn, { attributes: true, attributeFilter: ['disabled'] });
    }
    const priceEl = pdp.querySelector('[data-sz-rd-price]');
    const compareEl = pdp.querySelector('[data-sz-rd-compare]');
    const chip = pdp.querySelector('[data-sz-rd-stockchip]');
    const preNote = pdp.querySelector('[data-sz-rd-prenote]');
    const outNote = pdp.querySelector('[data-sz-rd-outnote]');
    const consentWrap = pdp.querySelector('[data-sz-rd-consent]');
    const consentBox = pdp.querySelector('[data-sz-rd-consent-box]');
    const bonusNote = pdp.querySelector('[data-sz-rd-bonus]');
    const btnDep = pdp.querySelector('[data-sz-rd-btn-dep]');
    const lineTotal = pdp.querySelector('[data-sz-rd-linetotal]');
    const payIn4Amt = pdp.querySelector('[data-sz-rd-payin4-amt]'); // PAY-IN-4-01
    const depNote = pdp.querySelector('[data-sz-rd-dep]');
    const purchaseWrap = pdp.querySelector('[data-sz-rd-purchase-wrap]');
    const tiersWrap = pdp.querySelector('[data-sz-rd-tiers-wrap]');

    /* ---------- pre-order consent: ours drives the app's ----------
     * Restock Rocket renders its own acknowledgement checkbox
     * (#restock-rocket-acknowledge-preorder, measured on live 2026-08-15) and
     * keeps the add button `disabled` until it is ticked. Its label asks the
     * customer to agree to "the preorder terms and conditions" while linking to
     * NOTHING, which is the part worth replacing.
     *
     * So: hide theirs, show ours — ours names the terms and links to them — and
     * mirror our state onto their input so their gate is satisfied.
     *
     * FAIL-SAFE: theirs is only hidden once we have actually found it. If the
     * app changes its markup, the customer keeps a working control instead of
     * being left with our checkbox and a button nothing can enable.
     */
    /* ---------- deposit figures: variant × QUANTITY ----------
     * Owner caught this on live: the button read "$4.50 due today" with a
     * quantity of 10 in the stepper, when the real charge would be $45.00.
     * `checkout_charge_amount` and `remaining_balance_charge_amount` come off
     * the VARIANT's allocation, so they are per-unit — the page must multiply.
     * A payment disclosure understating the charge by 10× is the same class of
     * fault this whole batch exists to fix, pointing the other way.
     *
     * Repainting therefore has two triggers, not one: choosing a variant and
     * changing the quantity. Both funnel through here so they cannot drift.
     */
    let lastVariant = null;
    const qtyNow = () => {
      const el = pdp.querySelector('[data-sz-rd-qty]');
      return el ? Math.min(99, Math.max(1, parseInt(el.value, 10) || 1)) : 1;
    };
    /* Pay-in-full choice (2026-09-09). 'full' only when the variant carries a full-payment
       plan AND the shopper picked it; everything else is the deposit plan. */
    const payChoice = () => {
      const r = pdp.querySelector('[data-sz-rd-pay]:checked');
      return r && r.value === 'full' ? 'full' : 'part';
    };
    const purchaseChoice = () => {
      const r = pdp.querySelector('[data-sz-rd-purchase]:checked');
      return r && r.value === 'reserve' ? 'reserve' : 'now';
    };
    // A between-batches variant is always a pre-order. A stocked variant only
    // enters the same flow after an explicit Reserve choice. Keeping this
    // separate from inventory state lets Buy now remain a plain Shopify line.
    const wantsPreorder = (v) => !!v.pre || purchaseChoice() === 'reserve';
    const pickPlan = (v) => (v.avail && wantsPreorder(v) ? (payChoice() === 'full' && v.planFull ? v.planFull : v.plan) : null);
    const depFull = pdp.querySelector('[data-sz-rd-dep-full]');
    const depFullNum = pdp.querySelector('[data-sz-rd-dep-full-num]');
    const depFullSave = pdp.querySelector('[data-sz-rd-dep-full-save]');
    const consentBal = pdp.querySelector('[data-sz-rd-consent-bal]');
    const payOpt = pdp.querySelector('[data-sz-rd-payopt]');
    const payPartSub = pdp.querySelector('[data-sz-rd-pay-part-sub]');
    const payFullSub = pdp.querySelector('[data-sz-rd-pay-full-sub]');
    const paintDeposit = () => {
      const v = lastVariant;
      if (!v) return;
      const preorderActive = v.avail && wantsPreorder(v) && !!(v.plan || v.planFull);
      const full = preorderActive && payChoice() === 'full' && !!v.planFull;
      // A plan whose allocation leaves NO balance (bal 0, or dep = price) is not a deposit: it
      // is a pre-order paid in full. Never print "$X today · $0 charged automatically".
      const paidInFull = preorderActive && (full || (!!v.plan && v.bal === 0));
      const deferred = preorderActive && !!v.plan && !paidInFull;
      if (payOpt) {
        payOpt.hidden = !(preorderActive && v.planFull);
        if (payPartSub && typeof v.dep === 'number' && typeof v.bal === 'number' && v.bal > 0) payPartSub.textContent = money(v.dep) + ' today · ' + money(v.bal) + (pdp.querySelector('[data-sz-rd-shipdate]:not([hidden])') ? ' before your shipping date' : ' before your order ships, within ' + (payOpt.dataset.window || 21) + ' days');
        if (payFullSub && typeof v.priceFull === 'number') payFullSub.textContent = money(v.priceFull) + ' today (save ' + money(Math.max(0, v.price - v.priceFull)) + ') · nothing more to pay';
      }
      if (depFull) {
        depFull.hidden = !paidInFull;
        if (paidInFull) {
          const unit = full && typeof v.priceFull === 'number' ? v.priceFull : (typeof v.dep === 'number' && v.dep > 0 ? v.dep : v.price);
          if (depFullNum) depFullNum.textContent = money(unit * qtyNow());
          if (depFullSave) depFullSave.textContent = full && v.priceFull < v.price ? '(' + money((v.price - v.priceFull) * qtyNow()) + ' off)' : '';
        }
      }
      if (consentBal) consentBal.hidden = !deferred;
      const qty = qtyNow();
      // BOTH figures must come from the allocation. Deriving the balance as
      // price - deposit ignores discounts, and the "Limited Time Deals" volume
      // Functions take up to 20% off pre-order lines server-side, so a derived
      // balance would overstate what is owed.
      const hasFigure =
        deferred &&
        typeof v.dep === 'number' && v.dep > 0 &&
        typeof v.bal === 'number' && v.bal > 0;
      if (depNote) {
        depNote.hidden = !(deferred || paidInFull);
        if (depNum) depNum.hidden = !hasFigure;
        if (depGeneric) depGeneric.hidden = !deferred ? true : hasFigure;
        if (hasFigure) {
          if (depToday) depToday.textContent = money(v.dep * qty);
          if (depBal) depBal.textContent = money(v.bal * qty);
        } else {
          // Blank rather than merely hide: a hidden real number belonging to the
          // previous variant or quantity is one CSS regression away from being
          // a lie on a payment disclosure.
          if (depToday) depToday.textContent = '';
          if (depBal) depBal.textContent = '';
        }
      }
      if (btnDep) {
        btnDep.hidden = !(hasFigure || (paidInFull && full));
        if (hasFigure) btnDep.textContent = money(v.dep * qty) + ' due today';
        else if (paidInFull && full) btnDep.textContent = money(v.priceFull * qty) + ' today · save ' + money(Math.max(0, v.price - v.priceFull) * qty);
      }
      // Line total. Shown for EVERY product, not just pre-orders — the stepper
      // needs a visible consequence whatever the stock state, which is the
      // whole complaint. Hidden at qty 1 so it is not noise on page load.
      if (lineTotal) {
        const show = qty > 1;
        lineTotal.hidden = !show;
        if (show) lineTotal.textContent = qty + ' × ' + money(v.price) + ' = ' + money(v.price * qty);
      }
      // PAY-IN-4-01: Afterpay/Zip instalment follows grade and quantity.
      // BNPL can't be saved for a later charge, so a deposit order never offers
      // Afterpay/Zip: point to Pay in full instead of promising an instalment.
      if (payIn4Amt) {
        const box = payIn4Amt.closest('.sz-rd-payin4');
        const alt = box && box.querySelector('[data-sz-rd-payin4-alt]');
        const main = payIn4Amt.parentElement;
        if (alt) alt.hidden = !deferred;
        if (main) main.hidden = deferred;
        if (box) box.classList.toggle('is-deferred', deferred);
        const unit = full && typeof v.priceFull === 'number' ? v.priceFull : v.price;
        payIn4Amt.textContent = money(Math.floor((unit * qty) / 4));
      }
    };

    const rrConsent = () => document.getElementById('restock-rocket-acknowledge-preorder');
    const syncAppConsent = () => {
      const rr = rrConsent();
      if (!rr || !consentBox) return false;
      if (rr.checked !== consentBox.checked) {
        rr.checked = consentBox.checked;
        // Set the property, then announce it. The app listens for change; input
        // is dispatched too because a real tick fires both and we cannot know
        // which one it bound to.
        rr.dispatchEvent(new Event('input', { bubbles: true }));
        rr.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return true;
    };
    if (consentBox) {
      consentBox.addEventListener('change', () => {
        if (consentBox.checked) consentWrap.classList.remove('is-required');
        syncAppConsent();
      });
      // The box is `required` and the form is NOT novalidate, so the browser
      // blocks the submit before our handler runs — which is the behaviour we
      // want, but it means the JS gate below never fires on a normal click.
      // Hook the platform's own `invalid` event so the styled explanation
      // appears alongside the native bubble instead of competing with it.
      consentBox.addEventListener('invalid', () => {
        consentWrap.classList.add('is-required');
      });
      // Claim the app's control whenever it appears. This was a 250ms × 20 poll
      // and it FAILED ON LIVE (2026-08-15): Restock Rocket injects later than
      // the 5s window, the poll gave up, and the customer was left looking at
      // TWO consent checkboxes. An observer has no window to be wrong about —
      // it fires whenever the node actually arrives, early or late.
      const claimAppConsent = () => {
        const rr = rrConsent();
        if (!rr) return false;
        // A CLASS on <html>, not an inline style on their node. An inline style
        // is wiped the moment the app re-renders its own block, and the app
        // does re-render (a live `insertBefore` NotFoundError shows it moving
        // nodes around after we have touched them). The stylesheet rule cannot
        // be undone that way, and it is scoped to this class so it only ever
        // applies once OUR gate has actually been found — if the app changes
        // its markup, their control stays visible and usable.
        document.documentElement.classList.add('sz-rr-consent-claimed');
        // Lift the app's expected dispatch date into our disclosure, then let
        // the CSS hide the panel it came from. That panel otherwise restates
        // the deposit ("Pay 50% now") and the bonus, both of which we already
        // say — and say better, in real dollars rather than a percentage. The
        // date is the one fact only the app knows.
        // Guarded: if the field is absent the span stays hidden, so the
        // sentence never ends mid-air, and the panel is only hidden once we
        // have actually taken the date off it.
        const shipEl = document.querySelector('[data-sz-rd-shipdate]');
        const shipInput = document.querySelector('input[name="properties[Shipping]"]');
        if (shipEl && shipInput && shipInput.value) {
          // "before <date>" with the date as a pill (owner 2026-09-08); the setting's
          // phrase ("before your order ships") steps aside once the real date is known.
          shipEl.textContent = 'before ';
          var datePill = document.createElement('b');
          datePill.className = 'sz-rd-pdp__depdate';
          datePill.textContent = shipInput.value;
          shipEl.appendChild(datePill);
          var whenEl = document.querySelector('[data-sz-rd-dep-when]');
          if (whenEl) whenEl.hidden = true;
          shipEl.hidden = false;
          document.documentElement.classList.add('sz-rr-shipdate-claimed');
        }
        const block = rr.closest('.restock-rocket-acknowledgement-checkbox') || rr.parentElement;
        if (block) block.style.display = 'none';
        syncAppConsent();
        return true;
      };
      if (!claimAppConsent()) {
        const mo = new MutationObserver(() => {
          if (claimAppConsent()) mo.disconnect();
        });
        mo.observe(document.body, { childList: true, subtree: true });
        // Stop watching eventually rather than observing the whole document for
        // the life of the page. Generous, because the app has been seen taking
        // longer than 5s; if it never arrives its gate is not in play anyway.
        setTimeout(() => mo.disconnect(), 30000);
      }
    }
    const depNum = pdp.querySelector('[data-sz-rd-dep-num]');
    const depGeneric = pdp.querySelector('[data-sz-rd-dep-generic]');
    const depToday = pdp.querySelector('[data-sz-rd-dep-today]');
    const depBal = pdp.querySelector('[data-sz-rd-dep-bal]');
    const stage = pdp.querySelector('[data-sz-rd-stage]');

    const selected = groups.map((g) => {
      const active = g.querySelector('.sz-rd-optpill.is-active');
      return active ? active.dataset.szRdOptval : null;
    });

    /* Per-pill availability dots (owner 2026-09-09). For each option group, a pill's
       state is the state of the variant that would be selected by picking it while
       keeping the other groups as they are — so on a two-option product the Grade
       pills answer "this grade, in the size you have picked". in | pre | out, same
       rule as paintVariant. The legend shows only when something is not plain in-stock. */
    const pillKey = pdp.querySelector('[data-sz-rd-pillkey]');
    const paintPills = () => {
      if (!variants.length || !groups.length) return;
      let interesting = false;
      const words = { in: 'in stock', pre: 'pre-order', out: 'sold out' };
      groups.forEach((g, gi) => {
        g.querySelectorAll('.sz-rd-optpill').forEach((pill) => {
          const want = selected.slice();
          want[gi] = pill.dataset.szRdOptval;
          const match = variants.find((x) => x.opts.every((o, i) => want[i] == null || o === want[i]));
          if (!match) { delete pill.dataset.state; pill.removeAttribute('title'); pill.setAttribute('aria-label', pill.dataset.szRdOptval); return; }
          const st = match.avail ? (match.pre ? 'pre' : 'in') : 'out';
          pill.dataset.state = st;
          pill.title = pill.dataset.szRdOptval + ' — ' + words[st];
          pill.setAttribute('aria-label', pill.dataset.szRdOptval + ', ' + words[st]);
          if (st !== 'in') interesting = true;
        });
      });
      if (pillKey) pillKey.hidden = !interesting;
    };
    paintPills();

    pdp.querySelectorAll('[data-sz-rd-pay]').forEach((r) => r.addEventListener('change', () => paintVariant()));
    pdp.querySelectorAll('[data-sz-rd-purchase]').forEach((r) => r.addEventListener('change', () => paintVariant()));
    /* Purchase fold (PDP-SIMPLE-01, 2026-09-23): the pre-order radios live inside a
       <details>. Closing it with "reserve" selected snaps back to "now" — a choice the
       shopper can no longer see must never attach a selling plan to the add. */
    const prefold = pdp.querySelector('[data-sz-rd-prefold]');
    if (prefold) prefold.addEventListener('toggle', () => {
      if (prefold.open) return;
      const now = pdp.querySelector('[data-sz-rd-purchase][value="now"]');
      if (now && !now.checked) { now.checked = true; paintVariant(); }
    });
    /* Grade hint (PDP-SIMPLE-01): one plain line saying what the selected grade means,
       in the words GRADING-REFERENCE uses (pattern coverage and solidity — never health;
       the base colour of a galaxy/fancy line never changes with grade). */
    const gradeHint = pdp.querySelector('[data-sz-rd-gradehint]');
    const GRADE_ALIASES = {
      entry: 'entry', mid: 'mid', high: 'high', collector: 'collector', competition: 'collector',
      grade1: 'collector', grade2: 'high', grade3: 'mid', grade4: 'entry',
      g1: 'collector', g2: 'high', g3: 'mid', g4: 'entry'
    };
    const GRADE_HINTS = {
      entry: '<b>Entry</b> — pattern still filling in and less even between shrimp. Same hardy animals, best value.',
      mid: '<b>Mid</b> — good coverage with some variation between shrimp.',
      high: '<b>High</b> — strong, even pattern and solid colour.',
      collector: '<b>Collector</b> — the pick of the batch: near-full pattern, thick solid colour.'
    };
    const paintGradeHint = (v) => {
      if (!gradeHint) return;
      const key = (Array.isArray(v.opts) ? v.opts : [])
        .map((o) => String(o || '').toLowerCase().replace(/[^a-z0-9]+/g, ''))
        .map((o) => GRADE_ALIASES[o] || o)
        .find((o) => GRADE_HINTS[o]);
      if (key) { gradeHint.innerHTML = GRADE_HINTS[key]; gradeHint.hidden = false; }
      else { gradeHint.textContent = ''; gradeHint.hidden = true; }
    };
    /* Ship-date pill from our own field (2026-09-09): the Liquid renders it when szn.ship_date is
       set; nothing to do here except keep it in step with the stock state. */
    const shipOwn = pdp.querySelector('[data-sz-rd-shipdate]');
    const whenOwn = pdp.querySelector('[data-sz-rd-dep-when]');
    const paintVariant = (options) => {
      paintPills();
      if (!variants.length) return;
      const v = groups.length ? variants.find((x) => x.opts.every((o, i) => o === selected[i])) : variants[0];
      if (!v) return;
      paintGradeHint(v);
      if (priceEl) priceEl.textContent = money(v.price);
      if (compareEl) {
        if (v.cap > v.price) { compareEl.textContent = money(v.cap); compareEl.hidden = false; }
        else compareEl.hidden = true;
      }
      const state = v.avail ? (v.pre ? 'pre' : 'in') : 'out';
      const canChoosePurchase = state === 'in' && !!v.plan;
      if (purchaseWrap) purchaseWrap.hidden = !canChoosePurchase;
      if (!canChoosePurchase && state !== 'pre') {
        const nowChoice = pdp.querySelector('[data-sz-rd-purchase][value="now"]');
        if (nowChoice) nowChoice.checked = true;
      }
      const preorderActive = state === 'pre' || (state === 'in' && !!v.plan && wantsPreorder(v));
      if (chip) {
        chip.textContent = chip.dataset[state];
        chip.className = 'sz-rd-stockchip sz-rd-stockchip--' + state;
      }
      if (preNote) preNote.hidden = state !== 'pre';
      if (outNote) outNote.hidden = state !== 'out';
      if (addBtn) {
        addBtn.dataset.variantId = String(v.id);
        addBtn.dataset.szRdState = state; // the disable-guard observer reads this
        addBtn.disabled = state === 'out';
        addBtn.classList.toggle('is-pre', preorderActive);
        // The selling plan is what makes /cart/add.js defer the charge. It is
        // PER VARIANT, so it has to be re-set here — carrying a previous
        // grade's plan onto a variant that has none would defer a payment the
        // shopper was never shown, and dropping one that exists would charge
        // the full amount silently. Both directions are money bugs.
        const planId = pickPlan(v);
        if (planId) addBtn.dataset.sellingPlan = String(planId);
        else delete addBtn.dataset.sellingPlan;
      }
      // Keep the FORM fields in step with the data-attributes above. These are
      // what a native submit and any third-party form handler read, so a stale
      // hidden id adds the wrong grade — on a catalogue where grades run
      // $40/$100/$200, that is a real mischarge, not a cosmetic bug.
      const formIdInput = pdp.querySelector('[data-sz-rd-form-id]');
      if (formIdInput) formIdInput.value = String(v.id);
      const form = pdp.querySelector('[data-sz-rd-form]');
      if (form) {
        let planInput = form.querySelector('[data-sz-rd-form-plan]');
        const planId2 = pickPlan(v);
        if (planId2) {
          // The input is only server-rendered when the FIRST variant has a
          // plan, so it may not exist yet when switching onto one that does.
          if (!planInput) {
            planInput = document.createElement('input');
            planInput.type = 'hidden';
            planInput.name = 'selling_plan';
            planInput.setAttribute('data-sz-rd-form-plan', '');
            form.appendChild(planInput);
          }
          planInput.value = String(planId2);
          // Keep any app-injected copies in step rather than removing them —
          // the app reads its own field, and two fields disagreeing is worse
          // than two agreeing.
          form.querySelectorAll('input[name="selling_plan"]').forEach((el) => {
            el.value = String(planId2);
          });
        } else {
          // Remove EVERY selling_plan input, not just ours. Third-party
          // pre-order apps inject their own copy, and a stale one left behind
          // means a NATIVE (no-JS) submit posts a deposit plan for a variant
          // that has none. Removed rather than blanked: an empty field is
          // still submitted.
          form.querySelectorAll('input[name="selling_plan"]').forEach((el) => el.remove());
        }
        // Our own cart-line notes (2026-09-09, no app): the deposit percentage for the quick-view
        // split — only when the chosen plan really defers a balance — and the ship date, only on
        // a pre-order variant.
        const isDeposit = !!planId2 && planId2 === v.plan && typeof v.dep === 'number' && typeof v.bal === 'number' && v.bal > 0;
        let depInput = form.querySelector('[data-sz-rd-form-dep]');
        if (isDeposit) {
          if (!depInput) {
            depInput = document.createElement('input');
            depInput.type = 'hidden'; depInput.name = 'properties[_szdep]'; depInput.setAttribute('data-sz-rd-form-dep', '');
            form.appendChild(depInput);
          }
          depInput.value = String(Math.round((v.dep / v.price) * 100));
        } else if (depInput) depInput.remove();
        const shipInputOwn = form.querySelector('[data-sz-rd-form-ship]');
        if (shipInputOwn) shipInputOwn.disabled = !preorderActive;
      }
      // Deposit disclosure. Shown only when this variant BOTH is a pre-order and
      // actually carries a plan — never on the strength of the stock state
      // alone, or the page would promise a deposit that checkout does not take.
      {
        const deferred = preorderActive && !!v.plan;
        // The consent gate follows the plan: a pre-order with either plan (deposit or
        // paid in full) is bound by the pre-order terms.
        if (consentWrap) consentWrap.hidden = !deferred;
        if (consentBox) {
          consentBox.required = deferred;
        }
        // Bonus line rides with the pre-order state, not with the plan — the
        // offer applies to pre-ordering, whether or not a deposit is taken.
        if (bonusNote) bonusNote.hidden = !preorderActive;
      }
      if (tiersWrap) tiersWrap.hidden = state !== 'in' || preorderActive;
      // Money owed depends on the variant AND the quantity, so it is repainted
      // from one place that both callers reach (see paintDeposit).
      lastVariant = v;
      paintDeposit();
      // Jump the gallery to the media attached to THIS variant, so choosing a
      // grade shows that grade's photo/clip. `mainImg` used to live here and no
      // longer exists — it only survived because v.img was always null, which
      // would have stopped short-circuiting the moment variant media was added.
      if (!options || options.syncMedia !== false) {
        const gradeVideo = findGradeVideoSlide(v);
        if (gradeVideo >= 0) showSlide(gradeVideo, { play: true });
        else if (v.media !== null && v.media !== undefined) showSlide(v.media, { play: true });
        else {
          // No clip or photo for this grade (GRADE-MEDIA-02 FAIL, 2026-09-20): never leave
          // ANOTHER grade's clip on screen under this grade's pill. Go back to the first,
          // neutral product media instead.
          const cur = slides[slideIdx];
          const curAlt = cur ? String(cur.dataset.szRdMediaAlt || '').toLowerCase().trim() : '';
          if (cur && cur.querySelector('video') && /-(entry|mid|high|collector|competition)$/.test(curAlt)) showSlide(0);
        }
      }
      // volume tiles show per-unit prices derived from the SELECTED variant
      pdp.querySelectorAll('[data-sz-rd-tier]').forEach((tile) => {
        const value = parseFloat(tile.dataset.value) || 0;
        let disc = tile.dataset.type === 'fixed' ? v.price - value * 100 : (v.price * (100 - value)) / 100;
        if (disc < 0) disc = 0;
        const now = tile.querySelector('[data-sz-rd-tier-now]');
        const was = tile.querySelector('[data-sz-rd-tier-was]');
        if (now) now.textContent = money(disc);
        if (was) was.textContent = money(v.price);
      });

      /* Announce the grade to anything OUTSIDE the buy row that has to follow
       * it. Added 2026-08-21 for the "Make an offer" modal, whose product,
       * variant, SKU and price fields are Liquid-rendered once: a buyer who
       * picked the $200 Competition grade was sending an offer stamped with
       * the $40 entry variant, and the email looked complete, so the merchant
       * could not see it.
       *
       * An event rather than a direct call, because the alternative is this
       * function reaching into every optional feature that happens to be on
       * the page — the offer modal only exists on 8 products. Listeners get
       * the variant in `detail`; anything needing title or SKU (neither is in
       * this payload) keys off `detail.id` against its own map. */
      pdp.dispatchEvent(new CustomEvent('sz-rd:variant', { detail: { ...v, preorderActive }, bubbles: true }));
    };

    // Seed every purchase control without moving or playing variant media on
    // page load. This also reveals the reservation choice only after its JS
    // wiring is live, so a script failure cannot show a reserve option that
    // would submit as a plain full-price purchase.
    if (variants.length) {
      lastVariant = groups.length
        ? variants.find((x) => x.opts.every((o, i) => o === selected[i])) || variants[0]
        : variants[0];
      paintVariant({ syncMedia: false });
    }

    groups.forEach((g, gi) => {
      g.addEventListener('click', (e) => {
        const pill = e.target.closest('.sz-rd-optpill');
        if (!pill) return;
        selected[gi] = pill.dataset.szRdOptval;
        g.querySelectorAll('.sz-rd-optpill').forEach((p) => p.classList.toggle('is-active', p === pill));
        paintVariant();
      });
    });

    const syncTierSelection = () => {
      // Every quantity change reaches here — stepper buttons, the volume tiles,
      // and typing straight into the field — so it is the one place that has to
      // repaint the deposit. Miss it and the button keeps showing the 1-unit
      // figure while the customer buys ten.
      paintDeposit();
      const input = pdp.querySelector('[data-sz-rd-qty]');
      const qty = input ? parseInt(input.value, 10) || 1 : 1;
      pdp.querySelectorAll('[data-sz-rd-tier]').forEach((t) => {
        t.setAttribute('aria-pressed', String(Number(t.dataset.qty) === qty));
      });
    };

    // ---- gallery: one path for thumbs, arrows and keyboard ----
    const slides = stage ? Array.from(stage.querySelectorAll('[data-sz-rd-slide]')) : [];
    const counter = pdp.querySelector('[data-sz-rd-counter]');
    let slideIdx = 0;

    function findGradeVideoSlide(variant) {
      const aliases = {
        entry: 'entry', mid: 'mid', high: 'high', collector: 'collector', competition: 'collector',
        grade1: 'collector', grade2: 'high', grade3: 'mid', grade4: 'entry',
        g1: 'collector', g2: 'high', g3: 'mid', g4: 'entry'
      };
      const options = Array.isArray(variant && variant.opts) ? variant.opts : [];
      const grades = options.map((value) => String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ''))
        .map((value) => aliases[value] || value)
        .filter((value) => ['entry', 'mid', 'high', 'collector'].includes(value));
      if (!grades.length) return -1;
      const match = (names) => slides.findIndex((slide) => {
        if (!slide.querySelector('video')) return false;
        const alt = String(slide.dataset.szRdMediaAlt || '').toLowerCase().trim();
        return names.some((grade) => alt.endsWith('-' + grade));
      });
      const preferred = match(grades);
      // Preserve existing uploaded media names while customer-facing grades use Collector.
      return preferred >= 0 ? preferred : grades.includes('collector') ? match(['competition']) : -1;
    }

    const showSlide = (next, opts) => {
      if (!slides.length) return;
      // wrap: from the last slide, "next" returns to the first
      const idx = ((next % slides.length) + slides.length) % slides.length;
      slideIdx = idx;
      slides.forEach((slide, i) => {
        const on = i === idx;
        slide.classList.toggle('is-active', on);
        const v = slide.querySelector('video');
        if (v) {
          // Never leave a video playing behind a photo. Only autoplay the newly
          // shown one when the move came from a real interaction — muted, so
          // browsers allow it without a gesture.
          if (on && opts && opts.play) { const pr = v.play(); if (pr && pr.catch) pr.catch(() => {}); }
          else if (!on) { v.pause(); }
        }
        // YouTube/Vimeo keep playing when merely hidden; resetting src stops them.
        const ext = slide.querySelector('iframe');
        if (ext && !on && ext.src) { ext.src = ext.src; }
      });
      pdp.querySelectorAll('[data-sz-rd-thumb]').forEach((t) => {
        t.classList.toggle('is-active', Number(t.dataset.szRdThumb) === idx);
      });
      if (counter) counter.textContent = (idx + 1) + ' / ' + slides.length;
    };

    // Arrow keys move the gallery only while focus is inside it — a global
    // listener would hijack arrow keys for the whole page.
    const galleryEl = pdp.querySelector('.sz-rd-pdp__gallery');
    if (galleryEl && slides.length > 1) {
      galleryEl.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); showSlide(slideIdx - 1, { play: true }); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); showSlide(slideIdx + 1, { play: true }); }
      });
    }


    pdp.addEventListener('click', (e) => {
      const prev = e.target.closest('[data-sz-rd-prev]');
      if (prev) { showSlide(slideIdx - 1, { play: true }); return; }
      const next = e.target.closest('[data-sz-rd-next]');
      if (next) { showSlide(slideIdx + 1, { play: true }); return; }

      const thumb = e.target.closest('[data-sz-rd-thumb]');
      if (thumb && stage) {
        showSlide(Number(thumb.dataset.szRdThumb), { play: true });
        return;
      }
      const tier = e.target.closest('[data-sz-rd-tier]');
      if (tier) {
        const input = pdp.querySelector('[data-sz-rd-qty]');
        if (input) input.value = tier.dataset.qty;
        syncTierSelection();
        return;
      }
      const minus = e.target.closest('[data-sz-rd-qty-minus]');
      const plus = e.target.closest('[data-sz-rd-qty-plus]');
      if (minus || plus) {
        const input = pdp.querySelector('[data-sz-rd-qty]');
        if (input) {
          const cur = parseInt(input.value, 10) || 1;
          input.value = String(Math.min(99, Math.max(1, cur + (plus ? 1 : -1))));
          syncTierSelection();
        }
      }
    });
    pdp.addEventListener('input', (e) => {
      if (e.target.closest && e.target.closest('[data-sz-rd-qty]')) syncTierSelection();
    });
  }

  /* ---------- 5c. lot countdown tiles ---------- */
  // Redesign display layer over the auction panel's [data-sz-timer] (owner:
  // tile the countdown). The panel JS (shared twin — untouched) rewrites the
  // span's text every tick; we mirror it into unit tiles in a SIBLING node.
  // Observer watches THEIR span, writes go to OURS — no feedback loop
  // (GOTCHAS #12). The source span stays in the DOM as the screen-reader
  // text (CSS makes it visually hidden); tiles are aria-hidden.

  const lotTimer = document.querySelector('.sz-alot [data-sz-timer]');
  if (lotTimer) {
    const tiles = document.createElement('span');
    tiles.className = 'sz-rd-ttiles';
    tiles.setAttribute('aria-hidden', 'true');
    lotTimer.insertAdjacentElement('afterend', tiles);
    lotTimer.classList.add('sz-rd-timer-src');

    const renderTiles = () => {
      const text = lotTimer.textContent.trim();
      const parts = [];
      const re = /(\d+)\s*(day|hr|min|sec)s?/g;
      let m;
      while ((m = re.exec(text))) parts.push([m[1], m[2]]);
      if (!parts.length) {
        // non-numeric states ("—", "Any moment…") pass through as plain text
        tiles.classList.add('sz-rd-ttiles--plain');
        tiles.textContent = text;
        return;
      }
      tiles.classList.remove('sz-rd-ttiles--plain');
      tiles.textContent = '';
      parts.forEach(([value, unit]) => {
        const tile = document.createElement('span');
        tile.className = 'sz-rd-ttile';
        const v = document.createElement('b');
        v.textContent = value;
        const u = document.createElement('i');
        u.textContent = value === '1' ? unit : unit + 's';
        tile.append(v, u);
        tiles.appendChild(tile);
      });
      tiles.classList.toggle('is-final', lotTimer.classList.contains('sz-alot__timer--final'));
    };

    renderTiles();
    new MutationObserver(renderTiles).observe(lotTimer, {
      childList: true,
      characterData: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  /* ---------- 5d. cart page: line quantity / remove ---------- */
  // POST /cart/change.js then RELOAD — the bundle-discount function prices
  // the cart, so a Liquid re-render is the only display that always agrees
  // with checkout. MPA reload matches the rest of the theme.

  const cartRoot = document.querySelector('[data-sz-rd-cart]');
  if (cartRoot) {
    /* STOCK-CAP-1012: on load, trim any buy-now line over stock (then reload, saying why) and stop + at the stock count. */
    (function () {
      let saved = '';
      try { saved = sessionStorage.getItem('szStockNote') || ''; sessionStorage.removeItem('szStockNote'); } catch (e) {}
      const say = (text) => {
        let el = document.querySelector('[data-sz-stock-note]');
        if (!el) { el = document.createElement('p'); el.className = 'sz-rd-cart__stocknote'; el.setAttribute('role', 'status'); el.setAttribute('data-sz-stock-note', ''); cartRoot.before(el); }
        el.textContent = text;
      };
      if (saved) say(saved);
      if (!window.szStock) return;
      fetch((window.Shopify?.routes?.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } })
        .then((r) => (r.ok ? r.json() : null))
        .then((cart) => (cart ? window.szStock.enforce(cart).then((r) => ({ cart, r })) : null))
        .then((res) => {
          if (!res) return;
          const { cart, r } = res;
          if (r.changed) { try { sessionStorage.setItem('szStockNote', r.note); } catch (e) {} window.location.reload(); return; }
          cart.items.forEach((it, i) => {
            const cap = r.caps[it.key]; if (!cap) return;
            const plus = cartRoot.querySelector('[data-sz-rd-line-plus][data-line="' + (i + 1) + '"]');
            const body = plus && plus.closest('[data-sz-rd-line-row]');
            if (body) window.szStock.trimNudges(body, cap.max - it.quantity);
            if (!plus || it.quantity < cap.max) return;
            plus.disabled = true; plus.setAttribute('aria-label', 'No more in stock');
            const buyrow = plus.closest('.sz-rd-cart__buyrow') || plus.closest('.sz-rd-qty');
            if (buyrow && !body.querySelector('.sz-rd-cart__left')) { const t = document.createElement('p'); t.className = 'sz-rd-cart__left'; t.textContent = 'Only ' + cap.stock + ' in stock. Pre-order more from its page.'; buyrow.after(t); }
          });
        })
        .catch(() => {});
    })();
    let changing = false, quantityTimer = null;
    const quantities = new Map();
    const changeLine = (line, quantity, row) => {
      if (changing) return;
      quantities.set(line, quantity);
      if (row) {
        row.querySelectorAll('[data-qty]').forEach((control) => { control.dataset.qty = String(quantity); });
        const display = row.querySelector('.sz-rd-qty__input');
        if (display) { if ('value' in display) display.value = String(quantity); else display.textContent = String(quantity); }
      }
      clearTimeout(quantityTimer);
      quantityTimer = setTimeout(() => flushQuantities(), 180);
    };
    const flushQuantities = async () => {
      changing = true;
      cartRoot.setAttribute('aria-busy', 'true');
      cartRoot.querySelectorAll('button').forEach((control) => { control.disabled = true; });
      try {
        // Highest line first: removing a line cannot shift a later queued target.
        for (const [line, quantity] of [...quantities].sort((a,b) => b[0]-a[0])) {
          const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ line, quantity }),
          });
          if (!response.ok) throw new Error('Quantity could not be updated. Please check available stock.');
        }
      } catch (error) {
        window.alert(error.message || 'Unable to update your cart. Your saved quantities will be restored.');
      }
      // One authoritative refresh per burst, preserving shipping/deposit scripts.
      window.location.reload();
    };

    cartRoot.addEventListener('click', (e) => {
      const minus = e.target.closest('[data-sz-rd-line-minus]');
      const plus = e.target.closest('[data-sz-rd-line-plus]');
      const remove = e.target.closest('[data-sz-rd-line-remove]');
      const btn = minus || plus || remove;
      if (!btn) return;
      e.preventDefault();
      if (changing) return;
      const row = btn.closest('[data-sz-rd-line-row]');
      const line = Number(btn.dataset.line);
      /* REMOVE-1TAP-1013 (owner 2026-10-13 "it requires pressing remove twice"): the line used to stay on screen until the save
         and reload finished (seconds on a phone), so the first tap looked like nothing happened. It goes at once now. */
      if (remove) { if (row) row.hidden = true; changeLine(line, 0, row); return; }
      const qty = (quantities.has(line) ? quantities.get(line) : Number(btn.dataset.qty)) + (plus ? 1 : -1);
      changeLine(line, Math.max(0, qty), row);
    });
  }


  /* ---------- 7. cart shipping estimator ---------- */
  /* Rates come from Shopify's own delivery profiles (via the app's
     /apps/auction/ship-estimate, SHIP-EST-01) for the chosen
     state — never from numbers written into the theme, which would contradict
     checkout the moment a rate changes. Empty result is meaningful, not an
     error: the Live Shrimp profile excludes WA/NT/TAS, so a livestock cart
     bound for those states legitimately has no rate, and saying so here beats
     letting the shopper discover it at checkout. */

  const shipRoot = document.querySelector('[data-sz-rd-ship]');
  if (shipRoot) {
    /* State is a radio-chip GROUP, not a <select> (2026-08-23). Read the
       CHECKED input rather than the element's own .value — a fieldset has no
       .value, so the old `stateEl.value` would be undefined and every cart
       would look like "no state chosen": checkout permanently disabled. */
    const stateRoot = shipRoot.querySelector('[data-sz-rd-ship-state]');
    const checkedState = () =>
      stateRoot ? stateRoot.querySelector('input[type="radio"]:checked') : null;
    const noteEl = shipRoot.querySelector('[data-sz-rd-ship-note]');
    const listEl = shipRoot.querySelector('[data-sz-rd-ship-rates]');
    const blockedEl = shipRoot.querySelector('[data-sz-rd-ship-blocked]');
    const checkoutBtn = document.querySelector('[data-sz-rd-checkout]');
    const hasLivestock = shipRoot.hasAttribute('data-has-livestock');

    /* WA/NT/TAS take no live animals (owner-ratified; the same three the
       concierge refuses in its state prefilter). Named explicitly rather than
       inferred from "no rates returned", because the delivery profile is not
       yet enforcing it — and when it is, the empty-rates branch below catches
       the same case. Dry-goods carts are never blocked: the ratified line is
       "dry goods are no problem anywhere in Australia". */
    const NO_LIVESTOCK_STATES = ['Western Australia', 'Northern Territory', 'Tasmania'];

    /* Two reasons checkout can be closed: no state chosen yet, or a livestock
       cart bound for a state we can't send animals to. Kept separate so the
       red exclusion panel only ever appears for the second. */
    const setCheckoutOpen = (open) => {
      if (!checkoutBtn) return;
      checkoutBtn.disabled = !open;
      checkoutBtn.setAttribute('aria-disabled', String(!open));
      checkoutBtn.classList.toggle('is-disabled', !open);
    };

    const setBlocked = (blocked) => {
      if (blockedEl) blockedEl.hidden = !blocked;
      setCheckoutOpen(!blocked);
    };

    /* Ask for the state BEFORE payment rather than after: the exclusion and
       the real rate both depend on it, and finding out at checkout is the
       worst place to learn we can't send live animals to you.
       Progressive enhancement matters here — the button is server-rendered
       ENABLED and only closed once this runs, so a JS failure leaves a
       working checkout rather than an unsellable cart (checkout collects the
       address anyway). */
    const requireState = () => {
      if (!stateRoot || !checkedState()) {
        setCheckoutOpen(false);
        if (blockedEl) blockedEl.hidden = true;
        showNote('Choose your state to see delivery prices before you pay. Free delivery on orders of $250 or more (soil, stone and wood excluded).');
        return true;
      }
      return false;
    };

    const showNote = (text) => {
      if (noteEl) noteEl.textContent = text;
      if (listEl) { listEl.hidden = true; listEl.textContent = ''; }
    };

    const renderRates = (rates, stateLabel) => {
      if (!listEl || !noteEl) return;
      if (!rates.length) {
        // NO rate came back. This is NOT proof the state is restricted — a
        // permitted state returns nothing whenever the rate table has a gap,
        // which is exactly what happened on 2026-08-13: carts over $200 had
        // no rate at all outside local delivery, and NSW was being told
        // "we can't send live animals there". Only the three named states
        // ever get the exclusion message; anything else is a rate problem and
        // must never accuse the shopper's state or block their checkout.
        showNote(`We couldn't get a rate for ${stateLabel} just now — shipping is worked out at checkout. If it can't find one there, message us and we'll sort it.`);
        return;
      }
      listEl.textContent = '';
      rates.forEach((rate) => {
        const li = document.createElement('li');
        li.className = 'sz-rd-ship__rate';
        const name = document.createElement('span');
        name.textContent = rate.name || rate.presentment_name || 'Shipping';
        const price = document.createElement('span');
        price.className = 'sz-rd-ship__price';
        const cents = Number(rate.price) * 100;
        price.textContent = cents <= 0 ? 'Free' : money(Math.round(cents));
        li.appendChild(name);
        li.appendChild(price);
        listEl.appendChild(li);
      });
      listEl.hidden = false;
      noteEl.textContent = 'Estimated for ' + stateLabel + '. Prices include GST.';
    };

    requireState();

    /* Listen on the GROUP: radio `change` bubbles, so one listener covers all
       eight chips and survives any future state being added to the markup. */
    stateRoot && stateRoot.addEventListener('change', () => {
      const sel = checkedState();
      const province = sel ? sel.value : '';
      const stateLabel = sel ? (sel.dataset.label || sel.value) : '';
      if (!province) { requireState(); return; }
      if (hasLivestock && NO_LIVESTOCK_STATES.indexOf(province) !== -1) {
        setBlocked(true);
        showNote('Live animals can’t be sent to ' + stateLabel + '.');
        return;
      }
      setBlocked(false);
      showNote('Checking rates…');
      // SHIP-EST-01 (2026-09-29): rates now come from the app, which asks
      // Shopify's draft-order calculator — same delivery profiles, same rates,
      // but a pure calculation. The old /cart/shipping_rates.json call made
      // Shopify SAVE the placeholder "VIC 3000" as the checkout's shipping
      // address, and Shop Pay then rejected the customer's real saved address
      // with "Selected address is incomplete" (found on a live checkout).
      const CODE = {
        Victoria: 'VIC', 'New South Wales': 'NSW', Queensland: 'QLD', 'South Australia': 'SA',
        'Australian Capital Territory': 'ACT', 'Western Australia': 'WA', 'Northern Territory': 'NT', Tasmania: 'TAS',
      };
      const fail = () => showNote('We couldn\u2019t check rates just now. They\u2019re shown at checkout.');
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then((r) => (r.ok ? r.json() : null))
        .then((cart) => {
          if (!cart) throw new Error('cart');
          const items = (cart.items || []).map((i) => ({ variantId: i.variant_id, quantity: i.quantity }));
          return fetch('/apps/auction/ship-estimate', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ province: CODE[province] || province, items }),
          });
        })
        .then((r) => (r && r.ok ? r.json() : null))
        .then((data) => {
          if (!data || !data.ok) { fail(); return; }
          renderRates(data.rates || [], stateLabel);
        })
        .catch(fail);
    });
  }

  /* ---------- 6. scroll-row dots ---------- */

  document.querySelectorAll('[data-sz-rd-row]').forEach((row) => {
    /* ⚠️ NO early return on a missing dotsBox. This block also owns the scroll
       bar and the autoplay, and gating all three on one optional element is
       exactly the fault recorded as #143 — which was then repeated here on
       2026-08-25 when the row layouts swapped dots for the bar and every bar
       silently stayed hidden. Each feature guards itself. */
    const dotsBox = row.parentElement.querySelector('[data-sz-rd-rowdots]');
    const build = () => {
      if (!dotsBox) return;
      const pages = Math.min(6, Math.max(1, Math.ceil(row.scrollWidth / Math.max(1, row.clientWidth))));
      if (pages < 2 || getComputedStyle(dotsBox).display === 'none') { dotsBox.innerHTML = ''; return; }
      dotsBox.innerHTML = '';
      for (let k = 0; k < pages; k += 1) {
        /* BUTTON, not span (2026-08-25). These were decorative while the rows
           were mobile-only. Now that rows carry the homepage carousels the dot
           is the only visible affordance for "there is more to the right", so
           it has to be operable by click and by keyboard — and countable by the
           tap-target prover, which reads button.sz-rd-dot. */
        const d = document.createElement('button');
        d.type = 'button';
        d.className = 'sz-rd-dot' + (k === 0 ? ' is-active' : '');
        d.setAttribute('aria-label', 'Show items ' + (k + 1) + ' of ' + pages);
        d.addEventListener('click', () => {
          row.scrollTo({ left: k * row.clientWidth, behavior: 'smooth' });
        });
        dotsBox.appendChild(d);
      }
    };
    const paint = () => {
      if (!dotsBox) return;
      const dots = dotsBox.children;
      if (!dots.length) return;
      const p = Math.min(
        dots.length - 1,
        Math.round((row.scrollLeft / Math.max(1, row.scrollWidth - row.clientWidth)) * (dots.length - 1))
      );
      Array.from(dots).forEach((d, k) => d.classList.toggle('is-active', k === p));
    };
    build();
    row.addEventListener('scroll', paint, { passive: true });
    window.addEventListener('resize', build);

    /* Drag the ROW itself (owner 2026-09-06: "slide across without using the
       sliding bar"). Mouse and pen only — touch already swipes natively and a
       pointer handler on top of it would double-scroll. Same two switches the
       bar's drag needs (smooth off, snap off) for the same reason: each
       scrollLeft assignment would otherwise start an animation the next one
       cancels. A drag past 6px swallows the click that follows, so letting go
       on a card does not open it; a plain click still does. */
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      let dragX = null;
      let dragScroll = 0;
      let dragged = false;
      row.classList.add('sz-rd-row--draggable');
      row.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'touch' || e.button !== 0) return;
        dragX = e.clientX; dragScroll = row.scrollLeft; dragged = false;
      });
      row.addEventListener('pointermove', (e) => {
        if (dragX === null) return;
        const dx = e.clientX - dragX;
        if (!dragged && Math.abs(dx) < 6) return;
        if (!dragged) {
          dragged = true;
          row.classList.add('is-dragging');
          row.style.scrollBehavior = 'auto';
          row.style.scrollSnapType = 'none';
          try { row.setPointerCapture(e.pointerId); } catch (_) {}
        }
        row.scrollLeft = dragScroll - dx;
        e.preventDefault();
      });
      const endRowDrag = (e) => {
        if (dragX === null) return;
        dragX = null;
        if (dragged) {
          row.classList.remove('is-dragging');
          row.style.scrollBehavior = '';
          row.style.scrollSnapType = '';
          try { row.releasePointerCapture(e.pointerId); } catch (_) {}
        }
      };
      row.addEventListener('pointerup', endRowDrag);
      row.addEventListener('pointercancel', endRowDrag);
      row.addEventListener('lostpointercapture', endRowDrag);
      row.addEventListener('click', (e) => {
        if (!dragged) return;
        dragged = false;
        e.preventDefault(); e.stopPropagation();
      }, true);
      row.addEventListener('dragstart', (e) => { if (dragX !== null) e.preventDefault(); });
    }

    /* Auto-slide, desktop only (owner request 2026-08-25).
       Deliberately NOT a carousel library: this nudges scrollLeft by one
       viewport and wraps, so the row stays a plain scroller that keyboard,
       touch and screen readers already understand.
       Three ways it stops, because a row that moves while you are reading a
       card is worse than one that never moves: reduced-motion, a narrow
       viewport, and any manual interaction for 12s. */
    /* Arrows. Same scroll unit as the dots and the autoplay, so all three
       controls agree about what "one step" means. Hidden when the row does not
       overflow — an arrow that does nothing is worse than no arrow. */
    /* The scroll bar. Thumb width = how much of the row is visible, thumb
       position = where you are. Draggable and clickable, so it replaces the
       arrows as the control as well as the dots as the indicator. */
    const wrap2 = row.closest('.sz-rd-rowwrap');
    const bar = wrap2 && wrap2.querySelector('[data-sz-rd-rowbar]');
    const track = bar && bar.querySelector('[data-sz-rd-rowtrack]');
    const thumb = bar && bar.querySelector('[data-sz-rd-rowthumb]');
    if (bar && track && thumb) {
      const maxScroll = () => row.scrollWidth - row.clientWidth;
      const paintBar = () => {
        const max = maxScroll();
        if (max <= 8) { bar.hidden = true; return; }
        bar.hidden = false;
        const frac = Math.min(1, row.clientWidth / row.scrollWidth);
        const tw = Math.max(36, track.clientWidth * frac);
        const pos = (row.scrollLeft / max) * (track.clientWidth - tw);
        thumb.style.width = tw + 'px';
        thumb.style.left = Math.max(0, Math.min(track.clientWidth - tw, pos)) + 'px';
        thumb.setAttribute('aria-valuenow', String(Math.round((row.scrollLeft / max) * 100)));
      };
      paintBar();
      row.addEventListener('scroll', paintBar, { passive: true });
      window.addEventListener('resize', paintBar);

      /* Drag. Pointer events cover mouse, pen and touch in one path, and the
         capture means a drag that leaves the bar still tracks. */
      let dragging = false;
      let startX = 0;
      let startScroll = 0;
      const ratio = () => {
        const tw = thumb.offsetWidth;
        const span = track.clientWidth - tw;
        return span > 0 ? maxScroll() / span : 0;
      };
      thumb.addEventListener('pointerdown', (e) => {
        dragging = true; startX = e.clientX; startScroll = row.scrollLeft;
        /* The row is scroll-behavior:smooth for the arrows and autoplay. During
           a DRAG that is fatal: every scrollLeft assignment starts a fresh
           animation that the next one cancels, so the row barely moves — a drag
           of 260px produced 0px until this was turned off. Restored on release
           so programmatic scrolls stay smooth. */
        row.style.scrollBehavior = 'auto';
        /* Mandatory snap fights a drag too: the browser re-snaps to the nearest
           card after every scrollLeft we set, so the thumb feels stuck and the
           row lurches. Off while dragging, back on when the pointer lifts, so
           the row still settles on a card boundary after a flick or an arrow. */
        row.style.scrollSnapType = 'none';
        try { thumb.setPointerCapture(e.pointerId); } catch (_) {}
        e.preventDefault();
      });
      thumb.addEventListener('pointermove', (e) => {
        if (!dragging) return;
        row.scrollLeft = startScroll + (e.clientX - startX) * ratio();
      });
      const endDrag = (e) => {
        if (!dragging) return;
        dragging = false;
        row.style.scrollBehavior = '';
        row.style.scrollSnapType = '';
        try { thumb.releasePointerCapture(e.pointerId); } catch (_) {}
      };
      thumb.addEventListener('pointerup', endDrag);
      thumb.addEventListener('pointercancel', endDrag);

      /* Click the track to jump. */
      track.addEventListener('pointerdown', (e) => {
        if (e.target === thumb) return;
        const r = track.getBoundingClientRect();
        const tw = thumb.offsetWidth;
        const pos = Math.max(0, Math.min(track.clientWidth - tw, e.clientX - r.left - tw / 2));
        row.scrollTo({ left: pos * ratio(), behavior: 'smooth' });
      });

      /* Keyboard, because a scrollbar that only works with a mouse is not one. */
      thumb.addEventListener('keydown', (e) => {
        const step = row.clientWidth * 0.6;
        if (e.key === 'ArrowRight') { row.scrollBy({ left: step, behavior: 'smooth' }); e.preventDefault(); }
        if (e.key === 'ArrowLeft') { row.scrollBy({ left: -step, behavior: 'smooth' }); e.preventDefault(); }
      });
    }

    if (!row.hasAttribute('data-sz-rd-autoslide')) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    const wide = window.matchMedia('(min-width: 768px)');
    let timer = null;
    let pausedUntil = 0;
    const step = () => {
      if (document.hidden || Date.now() < pausedUntil) return;
      const max = row.scrollWidth - row.clientWidth;
      if (max < 8) return;
      const atEnd = row.scrollLeft + row.clientWidth >= max - 8;
      row.scrollTo({ left: atEnd ? 0 : row.scrollLeft + row.clientWidth, behavior: 'smooth' });
    };
    const start = () => {
      if (timer || reduce.matches || !wide.matches) return;
      timer = setInterval(step, 5000);
    };
    const stop = () => { if (timer) { clearInterval(timer); timer = null; } };
    /* Hovering STOPS the row for good, it no longer merely pauses. A row that
       resumes moving while the pointer is still on a card is what reads as
       "off alignment while hovering" — the geometry is identical either way
       (measured: every card top 231, height 536, transform none). Once someone
       has reached for a card, the carousel has done its job. */
    const halt = () => { pausedUntil = Number.MAX_SAFE_INTEGER; stop(); };
    row.addEventListener('mouseenter', halt);
    row.addEventListener('focusin', halt);
    row.addEventListener('touchstart', halt, { passive: true });
    row.addEventListener('wheel', halt, { passive: true });
    row.addEventListener('pointerdown', halt);
    reduce.addEventListener('change', () => (reduce.matches ? stop() : start()));
    wide.addEventListener('change', () => (wide.matches ? start() : stop()));
    start();
  });
})();

/* Signup offer (2026-09-08, intent signup-offer). The theme's own "$20 voucher on
   first order" card — markup in snippets/sz-rd-signup-offer.liquid, styles under
   "Signup offer" in sz-rd.css. It replaces Klaviyo's onsite form, which on a phone
   dropped a full-screen lid, locked the body and drew its card at half scale
   (GOTCHAS #177). Rules, all owner-chosen 2026-09-08:
     · show after the page has been open `data-delay` seconds AND (if data-scroll)
       the visitor has scrolled past the hero; `?sz_signup=1` skips the timing only;
     · never again after a signup; not for `data-suppress-days` after a decline
       (close ×, scrim, Escape and "No thanks" all count as a decline);
     · a visitor who already declined or completed Klaviyo's form is left alone;
     · the page behind is never locked — no body class, no overflow:hidden;
     · the email posts to Klaviyo's CLIENT subscription endpoint with the PUBLIC
       company id; the "Welcom" flow (Added to List) emails the NEWCUSTOMER code.
   Separately, body[data-sz-kl-off] (layout, setting signup_hide_klaviyo) keeps
   Klaviyo's form from locking the page: the CSS hides its wrappers, and the
   observer below strips the body class the moment Klaviyo adds it. */
(function () {
  if (document.body.hasAttribute('data-sz-kl-off')) {
    var unlock = function () {
      var b = document.body;
      if (b.classList.contains('klaviyo-prevent-body-scroll') || b.classList.contains('klaviyo-prevent-body-scrolling')) {
        b.classList.remove('klaviyo-prevent-body-scroll', 'klaviyo-prevent-body-scrolling');
      }
      if (b.style.overflow === 'hidden') b.style.overflow = '';
    };
    new MutationObserver(unlock).observe(document.body, { attributes: true, attributeFilter: ['class', 'style'] });
    unlock();
  }

  var root = document.querySelector('[data-sz-rd-signup]');
  if (!root) return;
  var KEY = 'sz-rd-signup';
  var panel = root.querySelector('[data-sz-rd-signup-panel]');
  var form = root.querySelector('[data-sz-rd-signup-form]');
  var err = root.querySelector('[data-sz-rd-signup-err]');
  var offerState = root.querySelector('[data-sz-rd-signup-state="offer"]');
  var doneState = root.querySelector('[data-sz-rd-signup-state="done"]');
  var open = false;

  function read() { try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } }
  function write(patch) {
    try {
      var d = read();
      for (var k in patch) d[k] = patch[k];
      localStorage.setItem(KEY, JSON.stringify(d));
    } catch (e) { /* private mode: the offer just shows again next visit */ }
  }
  function klaviyoAnswered() {
    try {
      var d = JSON.parse(localStorage.getItem('klaviyoOnsite') || '{}');
      var forms = d && d.viewedForms && d.viewedForms.modal && d.viewedForms.modal.disabledForms;
      return !!(forms && Object.keys(forms).length);
    } catch (e) { return false; }
  }
  function suppressed() {
    var d = read();
    if (d.doneAt) return true;
    if (klaviyoAnswered()) return true;
    var days = Number(root.dataset.suppressDays) || 14;
    return !!(d.declinedAt && Date.now() - d.declinedAt < days * 864e5);
  }
  /* POPUP-STACK-01 (2026-09-30): the offer never lands on top of another floating
     card — the "Make an offer" dialog, the menu, the Judge.me review popup or the
     Pips teaser. It waits and tries again. */
  function visible(el) {
    if (!el) return false;
    var s = getComputedStyle(el);
    if (s.display === 'none' || s.visibility === 'hidden' || +s.opacity < 0.05) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < window.innerHeight;
  }
  function anotherDialogOpen() {
    var offer = document.querySelector('.sz-rd-offer__backdrop');
    if (offer && !offer.hidden) return true;
    if (document.body.classList.contains('sz-rd-menu-open')) return true;
    if (visible(document.querySelector('.jdgm-popup-widget__cards-container'))) return true;
    var teaser = document.getElementById('sz-concierge-teaser');
    return !!(teaser && teaser.classList.contains('is-shown') && visible(teaser));
  }

  /* SIGNUP-SIDE-01: "side" mode = a tab on the left edge that expands on hover or
     click and never opens itself; "modal" = the original centre card / bottom sheet. */
  var side = root.dataset.mode !== 'modal';
  var tab = root.querySelector('[data-sz-rd-signup-tab]');
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var armed = false;
  var pinned = false;
  var hoverTimer = 0;
  if (side) root.classList.add('sz-rd-signup--side');

  /* SIGNUP-SIDE-02 (owner 2026-10-01): periodic, not constant. In a visit the
     tab appears SHOWS_PER_VISIT times, VISIBLE_MS each, SPACING_MS apart, then
     slides away by itself if nobody touched it. The schedule lives in
     sessionStorage, so it carries across page changes (a showing that is half
     over when the customer clicks through finishes on the next page). The next
     visit that can show it is GAP_DAYS later. After MAX_IGNORED visits in a row
     where nobody opened it, it rests REST_DAYS. Opening it resets that count. */
  var VISIBLE_MS = 20000;
  var SPACING_MS = 3 * 60000;
  var SHOWS_PER_VISIT = 2;
  var GAP_DAYS = 2;
  var MAX_IGNORED = 3;
  var REST_DAYS = 30;
  var VKEY = KEY + ':visit';
  var engaged = false;
  function visit() { try { return JSON.parse(sessionStorage.getItem(VKEY) || '{}'); } catch (e) { return {}; } }
  function saveVisit(v) { try { sessionStorage.setItem(VKEY, JSON.stringify(v)); } catch (e) { /* ignore */ } }
  /* Where this page sits in the visit's schedule: finish a showing that is
     still running, or book the next one. Returns false before the first. */
  function plan() {
    var v = visit();
    if (!v.n) return false;
    var now = Date.now();
    var end = v.at + VISIBLE_MS;
    if (now < end) arm(end - now);
    else if (v.n < SHOWS_PER_VISIT) setTimeout(function () { arm(); }, Math.max(0, end + SPACING_MS - now));
    return true;
  }
  /* arm() starts a new showing; arm(ms) continues one for its remaining ms. */
  function arm(remaining) {
    if (armed || suppressed()) return;
    if (anotherDialogOpen()) { setTimeout(function () { arm(remaining); }, 5000); return; }
    armed = true;
    root.hidden = false;
    var fresh = !remaining;
    if (fresh) {
      var v = visit();
      v.n = (v.n || 0) + 1;
      v.at = Date.now();
      saveVisit(v);
      if (v.n === 1) write({ shownAt: v.at, ignored: (Number(read().ignored) || 0) + 1 });
    }
    requestAnimationFrame(function () {
      root.classList.add('is-armed');
      if (fresh) root.classList.add('is-new');
    });
    setTimeout(function () {
      if (engaged || open || !armed) return;
      armed = false;
      root.classList.remove('is-armed', 'is-new');
      setTimeout(function () { if (!armed) root.hidden = true; }, 400);
      plan();
    }, remaining || VISIBLE_MS);
  }
  function expand(byHand) {
    if (!armed) { root.hidden = false; armed = true; root.classList.add('is-armed'); }
    if (byHand) pinned = true;
    if (!engaged) { engaged = true; write({ ignored: 0 }); }
    if (open) return;
    open = true;
    document.documentElement.classList.add('sz-signup-open');
    root.classList.remove('is-new');
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    if (tab) tab.setAttribute('aria-expanded', 'true');
    if (!byHand) return; /* a hover never moves focus */
    /* Focus the field only where that will not summon a keyboard over the sheet. */
    var input = form && form.querySelector('input[type="email"]');
    if (input && finePointer) input.focus({ preventScroll: true });
    else panel.focus({ preventScroll: true });
  }
  function collapse() {
    if (!open) return;
    open = false;
    pinned = false;
    document.documentElement.classList.remove('sz-signup-open');
    root.classList.remove('is-open');
    if (tab) tab.setAttribute('aria-expanded', 'false');
    if (panel.contains(document.activeElement) && tab) tab.focus({ preventScroll: true });
  }
  function hide() {
    open = false;
    document.documentElement.classList.remove('sz-signup-open');
    armed = false;
    root.classList.remove('is-open', 'is-armed', 'is-new');
    setTimeout(function () { root.hidden = true; }, 360);
  }
  function show() { if (side) arm(); else { armed = true; expand(true); write({ shownAt: Date.now() }); } }
  function decline() { write({ declinedAt: Date.now() }); hide(); }
  function done() { return doneState && !doneState.hidden; }
  function closeOrDecline() {
    if (done()) hide();
    else if (side) collapse();
    else decline();
  }

  root.querySelectorAll('[data-sz-rd-signup-close]').forEach(function (el) {
    el.addEventListener('click', closeOrDecline);
  });
  root.querySelectorAll('[data-sz-rd-signup-decline]').forEach(function (el) {
    el.addEventListener('click', decline);
  });
  if (tab) tab.addEventListener('click', function () {
    if (open && pinned) collapse(); else expand(true);
  });
  if (side && finePointer) {
    var busy = function () {
      var input = form && form.querySelector('input[type="email"]');
      return pinned || done() || (input && (input.value || document.activeElement === input));
    };
    var enter = function () { clearTimeout(hoverTimer); hoverTimer = setTimeout(function () { expand(false); }, 120); };
    var leave = function () {
      clearTimeout(hoverTimer);
      hoverTimer = setTimeout(function () { if (!busy()) collapse(); }, 450);
    };
    /* Hovering the small × must not open the panel, so only the tab itself and
       the open panel count as "in"; leaving either starts the fold-back timer. */
    [tab, panel].forEach(function (el) { if (el) el.addEventListener('mouseenter', enter); });
    [root.querySelector('[data-sz-rd-signup-tabwrap]'), panel].forEach(function (el) {
      if (el) el.addEventListener('mouseleave', leave);
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && open) closeOrDecline();
  });
  /* A click anywhere else folds a pinned side panel back to its tab. */
  if (side) document.addEventListener('click', function (e) {
    if (open && !root.contains(e.target)) { if (done()) hide(); else collapse(); }
  });

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('input[type="email"]');
      var btn = form.querySelector('button[type="submit"]');
      var email = (input.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        input.setAttribute('aria-invalid', 'true');
        err.textContent = err.dataset.invalid;
        err.hidden = false;
        input.focus();
        return;
      }
      input.removeAttribute('aria-invalid');
      err.hidden = true;
      btn.setAttribute('aria-busy', 'true');
      var body = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Shrimp Zone theme signup offer',
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: { list: { data: { type: 'list', id: root.dataset.list } } }
        }
      };
      fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(root.dataset.company), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', revision: '2025-10-15' },
        body: JSON.stringify(body)
      })
        .then(function (r) {
          if (!r.ok) throw new Error('klaviyo ' + r.status);
          write({ doneAt: Date.now() });
          offerState.hidden = true;
          doneState.hidden = false;
          var keep = doneState.querySelector('button');
          if (keep) keep.focus({ preventScroll: true });
        })
        .catch(function () {
          err.textContent = err.dataset.failed;
          err.hidden = false;
        })
        .then(function () { btn.removeAttribute('aria-busy'); });
    });
  }

  if (suppressed()) return;
  if (/[?&]sz_signup=1(&|$)/.test(location.search)) { show(); return; }
  if (/[?&]sz_signup=open(&|$)/.test(location.search)) { expand(true); return; }

  /* Timing (POPUP-01, owner 2026-09-23): never on the FIRST page of a visit —
     a signup asked for before anyone has seen a shrimp is the lowest-quality
     signup there is. Page views are counted per tab in sessionStorage; the
     sheet arms on the second view (the delay + scroll rules still apply on
     top), or on exit intent (pointer leaves through the top of the window) on
     any page after a short dwell. Once shown, not again for 30 days whatever
     the visitor did with it; a decline keeps its own longer suppression. */
  var SHOW_GAP = 30 * 864e5;
  var prior = read();
  if (side) {
    if (plan()) return; /* already shown this visit: follow its schedule */
    var since = prior.shownAt ? Date.now() - prior.shownAt : Infinity;
    if (since < GAP_DAYS * 864e5) return;
    if ((Number(prior.ignored) || 0) >= MAX_IGNORED && since < REST_DAYS * 864e5) return;
  } else if (prior.shownAt && Date.now() - prior.shownAt < SHOW_GAP) return;
  var views = 2; /* private mode / storage off: behave as before (second view) */
  try {
    var vkey = KEY + ':views';
    views = (Number(sessionStorage.getItem(vkey)) || 0) + 1;
    sessionStorage.setItem(vkey, String(views));
  } catch (e) { /* ignore */ }
  var armedAt = Date.now();
  var fired = false;
  function fire() {
    if (fired) return;
    fired = true;
    window.removeEventListener('scroll', onScroll);
    document.removeEventListener('mouseleave', onLeave);
    show();
  }

  var delay = (Number(root.dataset.delay) || 8) * 1000;
  var needScroll = root.dataset.scroll === '1';
  var timeUp = false;
  var scrolled = !needScroll;
  function maybe() {
    if (views >= 2 && timeUp && scrolled) fire();
  }
  function onScroll() {
    if (window.scrollY > Math.min(window.innerHeight * 0.6, 480)) { scrolled = true; maybe(); }
  }
  function onLeave(e) {
    if (e.clientY <= 0 && Date.now() - armedAt > 5000) fire();
  }
  setTimeout(function () { timeUp = true; maybe(); }, delay);
  if (needScroll) {
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
  if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.addEventListener('mouseleave', onLeave);
  }
})();

/* Info-tips + collapsible Description (2026-09-08, snippets/sz-rd-tip.liquid).
   The tip is a plain <details>, so it already opens on tap with no script; this
   adds what a <details> cannot do alone: hover on pointer devices, one-open-at-a-
   time, a flip to the right or upward edge when the panel would leave the
   viewport, and close on outside tap / Escape. The Description card is a
   <details> without `open` in the markup (a phone should see one row); on
   ≥ 768px there is room, so it is opened here at load. */
(function () {
  var tips = Array.prototype.slice.call(document.querySelectorAll('[data-sz-rd-tip]'));
  var desc = document.querySelector('[data-sz-rd-desc]');
  if (desc && window.matchMedia('(min-width: 768px)').matches) desc.open = true;
  if (!tips.length) return;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  function closeOthers(keep) { tips.forEach(function (t) { if (t !== keep) t.open = false; }); }
  function place(t) {
    /* The panel is positioned by its host row (CSS), so it cannot leave the viewport
       sideways; the only decision left is up or down. */
    var p = t.querySelector('.sz-rd-tip__panel');
    if (!p) return;
    t.classList.remove('sz-rd-tip--up');
    var r = p.getBoundingClientRect();
    if (r.bottom > window.innerHeight - 8 && r.top > r.height + 16) t.classList.add('sz-rd-tip--up');
  }
  tips.forEach(function (t) {
    t.addEventListener('toggle', function () { if (t.open) { closeOthers(t); place(t); } });
    if (fine) {
      var leaveTimer;
      t.addEventListener('mouseenter', function () { clearTimeout(leaveTimer); t.open = true; });
      t.addEventListener('mouseleave', function () { leaveTimer = setTimeout(function () { t.open = false; }, 120); });
      /* Hover has already opened it by the time a mouse click lands, so the native
         <summary> toggle would shut it again (found 2026-09-08 by the light-theme
         test pass, both engines). A click on an open tip keeps it open. */
      var sm = t.querySelector('summary');
      if (sm) sm.addEventListener('click', function (e) { if (t.open) e.preventDefault(); });
    }
  });
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-sz-rd-tip]')) return;
    closeOthers(null);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeOthers(null); });
})();

/* Whole-card navigation on desktop and phones (owner 2026-09-10). Follow the
   existing name link from otherwise inactive card space. Independent controls
   and text selection keep their jobs; the row's capture handler cancels clicks
   after a drag before they reach this delegated listener. */
(function () {
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var t = e.target;
    if (!t || !t.closest) return;
    var card = t.closest('.sz-rd-card');
    if (!card) return;
    if (t.closest('a, button, input, select, textarea, label, form, summary, [contenteditable]:not([contenteditable="false"]), [role="button"], [role="link"], [data-sz-rd-tip], [data-sz-wishlist]')) return;
    var selection = window.getSelection();
    if (selection && !selection.isCollapsed) return;
    var link = card.querySelector('.sz-rd-card__name a[href]');
    if (!link) return;
    window.location.href = link.href;
  });
})();

/* Theme switch (intent light-theme, 2026-09-08). The attribute is set before paint by
   the inline script in layout/sz-redesign.liquid; this only flips it, persists it, and
   keeps the controls and the browser chrome colour in step. */
(function () {
  var KEY = 'sz-theme';
  function get() { return document.documentElement.getAttribute('data-sz-theme') === 'light' ? 'light' : 'dark'; }
  function sync() {
    var light = get() === 'light';
    document.querySelectorAll('[data-sz-theme-toggle], [data-sz-theme-tab]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(light));
      b.setAttribute('aria-label', light ? 'Switch to dark theme' : 'Switch to light theme');
    });
    document.querySelectorAll('[data-sz-theme-set]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-sz-theme-set') === get()));
    });
    var meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute('content', light ? '#ffffff' : '#0b2b28');
  }
  function set(mode) {
    mode = mode === 'light' ? 'light' : 'dark';
    document.documentElement.setAttribute('data-sz-theme', mode);
    try { localStorage.setItem(KEY, mode); } catch (e) {}
    sync();
  }
  window.szTheme = { get: get, set: set };
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('[data-sz-theme-toggle], [data-sz-theme-tab], [data-sz-theme-set]');
    if (!t) return;
    e.preventDefault();
    set(t.hasAttribute('data-sz-theme-set') ? t.getAttribute('data-sz-theme-set') : (get() === 'light' ? 'dark' : 'light'));
  });
  sync();
})();

/* Chat tab (owner 2026-09-08): the tab bar's last tab opens the Pips concierge when its
   launcher is on the page; otherwise the link falls through to the contact page. */
(function () {
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('[data-sz-rd-chat-tab]');
    if (!t) return;
    var launcher = document.querySelector('.sz-concierge-launcher');
    if (!launcher) return;
    e.preventDefault();
    launcher.click();
  });
})();

/* Phone menu accordion (owner 2026-09-08: "previous section close if new one open"):
   opening one group's <details> closes the others, so the list never stacks two
   open trees. Native toggle event, no click hijacking, so summaries stay real targets. */
(function () {
  var menu = document.querySelector('[data-sz-rd-menu]');
  if (!menu) return;
  menu.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || !d.matches || !d.matches('.sz-rd-menu__group') || !d.open) return;
    menu.querySelectorAll('.sz-rd-menu__group[open]').forEach(function (o) { if (o !== d) o.open = false; });
  }, true);
})();

/* Cards-per-row switch (owner 2026-09-08). One stored value per device width so a phone's
   "1" never turns a desktop into one giant column; the inline script in the section applies
   the stored value before paint, this keeps the buttons and storage in step. */
(function () {
  var grid = document.querySelector('[data-sz-rd-grid]');
  var ctl = document.querySelector('[data-sz-rd-view]');
  if (!grid || !ctl) return;
  var mq = window.matchMedia('(max-width: 767px)');
  function key() { return mq.matches ? 'sz-rd-view-m' : 'sz-rd-view-d'; }
  function read() { try { return localStorage.getItem(key()); } catch (e) { return null; } }
  function apply(cols, store) {
    if (cols) grid.setAttribute('data-cols', cols); else grid.removeAttribute('data-cols');
    ctl.querySelectorAll('[data-sz-rd-view-cols]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-sz-rd-view-cols') === (cols || '')));
    });
    if (store) { try { localStorage.setItem(key(), cols || ''); } catch (e) {} }
  }
  apply(read() || (mq.matches ? '1' : null), false);
  ctl.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[data-sz-rd-view-cols]');
    if (!b) return;
    apply(b.getAttribute('data-sz-rd-view-cols'), true);
  });
  if (mq.addEventListener) mq.addEventListener('change', function () { apply(read() || (mq.matches ? '1' : null), false); });
})();
/* Description accordion (owner 2026-09-08: "make it so the section can collapse if clicking
   the title"). The product copy uses a radio-driven CSS accordion (.sz-acc__row > input
   [type=radio]); a radio cannot be un-ticked by a click, so the open row could never be
   closed. A click on the row that is already open un-ticks it. */
(function () {
  document.addEventListener('click', function (e) {
    var row = e.target && e.target.closest && e.target.closest('.sz-acc__row');
    if (!row) return;
    // The label's own click arrives first; the synthetic click it then fires on the
    // radio arrives with the radio already ticked and must pass untouched, or a
    // closed row could never open again.
    if (e.target.tagName === 'INPUT') return;
    var r = row.querySelector('input[type="radio"]');
    if (!r || !r.checked) return;
    e.preventDefault();
    r.checked = false;
  });
})();
/* Gallery swipe + thumb follow (owner 2026-09-08: "thumbnail can scroll to view random
   video or photos"). A horizontal swipe on the stage moves one slide, through the same
   prev/next controls the gallery already owns; the strip scrolls the active thumb into
   view so a long strip follows the stage. Vertical swipes still scroll the page. */
(function () {
  var stage = document.querySelector('.sz-rd-pdp__main');
  var pdp = stage && stage.closest('.sz-rd-pdp');
  if (!stage || !pdp) return;
  var x0 = null, y0 = null;
  stage.addEventListener('touchstart', function (e) { var t = e.touches && e.touches[0]; if (!t) return; x0 = t.clientX; y0 = t.clientY; }, { passive: true });
  stage.addEventListener('touchend', function (e) {
    if (x0 == null) return;
    var t = e.changedTouches && e.changedTouches[0]; if (!t) return;
    var dx = t.clientX - x0, dy = t.clientY - y0; x0 = y0 = null;
    if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
    var btn = pdp.querySelector(dx < 0 ? '[data-sz-rd-next]' : '[data-sz-rd-prev]');
    if (btn) btn.click();
  }, { passive: true });
  var follow = function () {
    var t = pdp.querySelector('[data-sz-rd-thumb].is-active');
    if (t && t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
  };
  pdp.querySelectorAll('[data-sz-rd-thumb]').forEach(function (t) {
    new MutationObserver(function () { if (t.classList.contains('is-active')) follow(); }).observe(t, { attributes: true, attributeFilter: ['class'] });
  });
})();
/* In-cart mode on the PDP (owner 2026-09-08: "make the button interactive, confirm when
   cart added, change interface to change cart when customer makes adjustment").
   Once this variant is in the cart the stepper edits that cart line (/cart/change.js,
   debounced), the row above the buy row says "In your cart: N", and the add button
   becomes "View cart". Zero removes the line and returns to add mode. A grade change
   re-evaluates against the last cart snapshot. Pre-order lines match by selling plan. */
(function () {
  var pdp = document.querySelector('[data-sz-rd-pdp]');
  var row = document.querySelector('[data-sz-rd-incart]');
  var btn = pdp && pdp.querySelector('.sz-rd-pdp__add');
  var qtyEl = pdp && pdp.querySelector('[data-sz-rd-qty]');
  if (!pdp || !row || !btn || !qtyEl) return;
  var qtyOut = row.querySelector('[data-sz-rd-incart-qty]');
  var note = row.querySelector('[data-sz-rd-incart-note]');
  var cart = null, line = null, timer = null, busy = false, pendingQuantity = null;

  function currentKey() {
    return { id: Number(btn.dataset.variantId), plan: Number(btn.dataset.sellingPlan) || null };
  }
  function findLine() {
    if (!cart || !cart.items) return null;
    var k = currentKey();
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      var alloc = it.selling_plan_allocation;
      var plan = alloc && alloc.selling_plan ? Number(alloc.selling_plan.id) : null;
      if (it.variant_id === k.id && plan === k.plan) return it;
    }
    return null;
  }
  function say(text, hold) {
    note.textContent = text || '';
    if (hold) setTimeout(function () { if (note.textContent === text) note.textContent = ''; }, hold);
  }
  function render() {
    line = findLine();
    var on = !!line;
    pdp.classList.toggle('is-in-cart', on);
    row.hidden = !on;
    if (on) { qtyOut.textContent = String(line.quantity); qtyEl.value = String(line.quantity); }
    else if (Number(qtyEl.value) < 1) qtyEl.value = '1';
  }
  function load() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c) { cart = c; render(); } })
      .catch(function () {});
  }
  function change(q) {
    if (!line) return;
    if (busy) { pendingQuantity = { key: currentKey(), quantity: q }; return; }
    var requestedKey = currentKey();
    busy = true; say('Updating…');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: line.key, quantity: q }),
    })
      .then(function (r) { if (!r.ok) throw new Error('change failed'); return r.json(); })
      .then(function (c) {
        cart = c; render();
        if (pendingQuantity && pendingQuantity.key.id === currentKey().id && pendingQuantity.key.plan === currentKey().plan) qtyEl.value = String(pendingQuantity.quantity);
        if (window.szRdSyncCart) window.szRdSyncCart();
        document.dispatchEvent(new CustomEvent('sz:cart-updated', { detail: { cart: c } }));
        say(q > 0 ? 'Cart updated ✓' : 'Removed from cart', 1800);
      })
      .catch(function () { pendingQuantity = null; render(); say('Could not update. Try the cart page.', 3000); })
      .finally(function () {
        busy = false;
        var next = pendingQuantity; pendingQuantity = null;
        if (next && next.key.id === currentKey().id && next.key.plan === currentKey().plan && requestedKey.id === next.key.id && requestedKey.plan === next.key.plan) change(next.quantity);
      });
  }
  function onQty() {
    if (!pdp.classList.contains('is-in-cart') || !line) return;
    clearTimeout(timer);
    var value = qtyEl.value.trim();
    if (!/^\d+$/.test(value)) return;
    var q = Math.max(1, Math.min(99, Number(value)));
    qtyEl.value = String(q);
    if (busy) { pendingQuantity = {key: currentKey(), quantity: q}; return; }
    var scheduledKey = currentKey();
    timer = setTimeout(function () {
      if (!line || currentKey().id !== scheduledKey.id || currentKey().plan !== scheduledKey.plan) return;
      if (q === line.quantity) return;
      change(q);
    }, 180);
  }
  // the stepper's own handlers set the input value before this bubbles up
  pdp.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-sz-rd-qty-minus], [data-sz-rd-qty-plus]')) setTimeout(onQty, 0);
  });
  qtyEl.addEventListener('input', onQty);
  qtyEl.addEventListener('change', onQty);
  // in cart mode the button is a link to the cart; capture phase so the submit path never runs
  // window capture runs before the cart module's document-level capture listener,
  // so in cart mode the tap can never reach the add path (it re-added 3 in testing).
  window.addEventListener('click', function (e) {
    if (!e.target.closest || e.target.closest('.sz-rd-pdp__add') !== btn) return;
    if (!pdp.classList.contains('is-in-cart') || btn.classList.contains('is-added')) return;
    e.preventDefault(); e.stopImmediatePropagation();
    window.location.href = row.querySelector('a').getAttribute('href');
  }, true);
  // after an add: let "Added" show, then switch to in-cart mode from a fresh snapshot
  document.addEventListener('sz-rd:added', function () { setTimeout(load, 1500); });
  document.addEventListener('sz-rd:variant', function () { render(); });
  load();
})();
/* Cart quick view (owner 2026-09-08: "make a quick view when click cart instead of direct
   to cart page"). The header cart icon opens a panel over the page: lines from /cart.js
   with image, name, grade, a stepper that edits the line (/cart/change.js), a remove
   button, subtotal, and View cart / Checkout. Esc, the scrim and the close button dismiss
   it; focus goes to the close button on open and back to the opener on close. The icon
   keeps its href, so with JS off it is still a link to the cart page. */
(function () {
  var qv = document.querySelector('[data-sz-rd-cartqv]');
  if (!qv) return;
  var list = qv.querySelector('[data-sz-rd-cartqv-list]');
  var empty = qv.querySelector('[data-sz-rd-cartqv-empty]');
  var foot = qv.querySelector('[data-sz-rd-cartqv-foot]');
  var count = qv.querySelector('[data-sz-rd-cartqv-count]');
  var subtotal = qv.querySelector('[data-sz-rd-cartqv-subtotal]');
  var splitEl = qv.querySelector('[data-sz-rd-cartqv-split]');
  var noteEl = qv.querySelector('[data-sz-rd-cartqv-note]');
  var noteDefault = noteEl ? noteEl.textContent : '';
  var closeBtn = qv.querySelector('[data-sz-rd-cartqv-close]');
  var scrim = document.querySelector('[data-sz-rd-cartqv-scrim]');
  var opener = null, busy = false, cart = null;

  function money(cents) {
    var d = cents / 100;
    return '$' + (d % 1 === 0 ? d.toFixed(0) : d.toFixed(2));
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  /* BAG-UI-1014 (10 Oct checkout test: "blank photo in the bag"): a product with no photo has image AND featured_image.url
     null in /cart.js (measured on live, Dark Red Ex KingKong), and the old placeholder was a faint stripe that read as an empty
     box. Now the same quiet plate as the product cards: an icon for the kind of product (template in the layout). A photo
     that fails to load falls back to the plate too. */
  var plates = qv.querySelector('template[data-sz-rd-cartqv-plates]');
  function kindOf(it) {
    var t = String(it.product_type || '').toLowerCase();
    return /shrimp|bonus/.test(t) ? 'shrimp' : /plant|moss|fern/.test(t) ? 'sprout' : /fish|snail|live/.test(t) ? 'droplets' : 'package';
  }
  function plate(kind) {
    var ico = plates && plates.content ? plates.content.querySelector('[data-kind="' + kind + '"]') : null;
    return '<span class="sz-rd-cartqv__ph sz-rd-cartqv__ph--plate" aria-hidden="true">' + (ico ? ico.innerHTML : '') + '</span>';
  }
  function img(it) {
    var url = it.image || (it.featured_image && it.featured_image.url) || '';
    if (!url) return plate(kindOf(it));
    var src = url.replace(/(\.[a-z]{3,4})(\?|$)/i, '_160x160$1$2');
    return '<img src="' + esc(src) + '" alt="" width="64" height="64" loading="lazy" data-sz-kind="' + kindOf(it) + '">';
  }
  function guardImages() {
    list.querySelectorAll('.sz-rd-cartqv__img img[data-sz-kind]').forEach(function (im) {
      function swap() { if (im.parentNode) im.outerHTML = plate(im.getAttribute('data-sz-kind')); }
      if (im.complete && im.naturalWidth === 0 && im.getAttribute('src')) { swap(); return; }
      im.addEventListener('error', swap, { once: true });
    });
  }
  var shipEl = qv.querySelector('[data-sz-rd-cartqv-ship]');
  function paintShip(c) {
    if (!shipEl) return;
    var th = Number(shipEl.getAttribute('data-threshold')) || 0;
    if (!(th > 0) || !c || !c.item_count) { shipEl.hidden = true; return; }
    var left = Math.max(0, th - c.total_price);
    shipEl.textContent = left > 0
      ? 'Spend ' + money(left) + ' more for free shipping (soil, stone and wood excluded).'
      : 'Free shipping on this order (soil, stone and wood excluded).';
    shipEl.toggleAttribute('data-unlocked', !(left > 0));
    shipEl.hidden = false;
  }
  /* BAG-NUDGE-01 (owner 2026-10-10, option C "Savings nudge in the bag"): under each shrimp line, a thin bar and one
     line saying how close it is to its next saving. Buy now: the Buy more save more ladder, counted per line (test bag
     2026-10-10: grades and products are not pooled). Pre-order (a line with a selling plan): 1 free for every 5. Lines in
     a live deal get nothing (bulk is off during a deal, owner 2026-10-10). Facts from #sz-bag-nudge in the layout. */
  var NUDGE = null;
  try { NUDGE = JSON.parse((document.getElementById('sz-bag-nudge') || {}).textContent || 'null'); } catch (e) { NUDGE = null; }
  var SHRIMP_TYPES = { 'Caridina Shrimp': 1, 'Neocaridina Shrimp': 1, 'Sulawesi Shrimp': 1 };
  /* DEAL-FIX-1011 (owner 2026-10-11): a line in a live pay-for-some, get-some-free offer (NUDGE.offers, from the layout)
     is counted together with every other buy-now line in the same offer, because the offer mixes lines, and the bag says
     how many more make the next free set. Shown once per offer, on its first line. Pre-order lines keep their own nudge
     (the offer does not apply to them). Test bags 2026-10-11: 14 = bulk only, 15 = 5 free, 20 = 5 free + 5 paid. */
  function offerOf(it) {
    var offers = (NUDGE && NUDGE.offers) || [];
    for (var i = 0; i < offers.length; i++) {
      var o = offers[i];
      if ((o.v || []).indexOf(String(it.variant_id)) > -1 || (o.p || []).indexOf(String(it.product_id)) > -1) return o;
    }
    return null;
  }
  function nudgeCtx(items) {
    var ctx = { pool: {}, shown: {} };
    (items || []).forEach(function (it) {
      if (it.selling_plan_allocation) return;
      var o = offerOf(it);
      if (o) ctx.pool[o.i] = (ctx.pool[o.i] || 0) + it.quantity;
    });
    return ctx;
  }
  function nudge(it, ctx) {
    if (!NUDGE || !SHRIMP_TYPES[it.product_type]) return '';
    var q = it.quantity, deal = NUDGE.deal || [];
    if (deal.indexOf('p' + it.product_id) > -1 || deal.indexOf('v' + it.variant_id) > -1) return '';
    var fill, text;
    var offer = it.selling_plan_allocation ? null : offerOf(it);
    if (offer) {
      if (!ctx || ctx.shown[offer.i]) return '';
      ctx.shown[offer.i] = 1;
      var oSet = offer.buy + offer.get, oT = ctx.pool[offer.i] || q, oSets = Math.floor(oT / oSet), oR = oT % oSet;
      if (!oR) {
        fill = 100;
        text = offer.label + '. ' + (oSets * offer.get) + ' shrimp free in your bag';
      } else {
        fill = oR / oSet * 100;
        text = offer.label + '. Add ' + (oSet - oR) + ' more and ' + offer.get + ' are free' + (oSets ? ' (' + (oSets * offer.get) + ' free already)' : '');
      }
    } else if (it.selling_plan_allocation) {
      var step = NUDGE.bonus || 5, free = Math.floor(q / step), left = step - (q % step);
      fill = (q % step === 0 && free) ? 100 : (q % step) / step * 100;
      text = (free ? free + ' free earned. ' : '') + 'Pre-order ' + left + ' more for ' + (free ? 'another' : '1') + ' free';
    } else {
      var tiers = (NUDGE.tiers || []).filter(function (t) { return t && t.type === 'percentage'; }).sort(function (a, b) { return a.quantity - b.quantity; });
      if (!tiers.length) return '';
      var cur = null, next = null;
      tiers.forEach(function (t) { if (q >= t.quantity) cur = t; else if (!next) next = t; });
      var top = tiers[tiers.length - 1];
      fill = Math.min(100, q / top.quantity * 100);
      text = next ? 'Add ' + (next.quantity - q) + ' more to save ' + next.value + '%' + (cur ? ' (saving ' + cur.value + '% now)' : '') : 'Top saving reached: ' + top.value + '% off';
    }
    return '<div class="sz-rd-nudge"><span class="sz-rd-nudge__bar" aria-hidden="true"><i style="width:' + Math.round(fill) + '%"></i></span><span class="sz-rd-nudge__text">' + esc(text) + '</span></div>';
  }
  /* BAG-NUDGE-01: the bag page's lines carry the same facts as data attributes; fill them once (the page reloads after
     every quantity change). */
  (function () {
    var lines = Array.prototype.map.call(document.querySelectorAll('[data-sz-rd-line-nudge]'), function (el) {
      return { el: el, it: { product_type: el.getAttribute('data-type'), quantity: +el.getAttribute('data-q'), product_id: +el.getAttribute('data-pid'), variant_id: +el.getAttribute('data-vid'), selling_plan_allocation: el.hasAttribute('data-plan') } };
    });
    var ctx = nudgeCtx(lines.map(function (l) { return l.it; }));
    lines.forEach(function (l) { l.el.innerHTML = nudge(l.it, ctx); });
  })();
  /* STOCK-CAP-1012: after each render, trim lines over stock (and say why) and stop + at the stock count. */
  var stockTok = 0, stockCaps = {}, stockNote = '';
  function sayStock(text) {
    var el = qv.querySelector('[data-sz-stock-note]');
    if (!el) { el = document.createElement('p'); el.className = 'sz-rd-cartqv__stock'; el.setAttribute('role', 'status'); el.setAttribute('data-sz-stock-note', ''); list.parentNode.insertBefore(el, list); }
    el.textContent = text; el.hidden = !text;
  }
  function applyStock(c) {
    if (!window.szStock || !c) return;
    var tok = ++stockTok;
    window.szStock.enforce(c).then(function (r) {
      if (tok !== stockTok) return;
      stockCaps = r.caps || {};
      if (r.changed) {
        stockNote = r.note; sayStock(stockNote);
        render(r.cart);
        if (window.szRdSyncCart) window.szRdSyncCart();
        document.dispatchEvent(new CustomEvent('sz:cart-updated', { detail: { cart: r.cart } }));
        return;
      }
      (cart && cart.items || []).forEach(function (it) {
        var cap = stockCaps[it.key]; if (!cap) return;
        var li = Array.from(qv.querySelectorAll('.sz-rd-cartqv__line')).find(function (row) { return row.getAttribute('data-key') === it.key; });
        if (li) window.szStock.trimNudges(li, cap.max - it.quantity);
        if (it.quantity < cap.max) return;
        var inc = li && li.querySelector('[data-sz-rd-cartqv-inc]');
        if (!inc) return;
        inc.disabled = true; inc.setAttribute('aria-label', 'No more in stock');
        if (!li.querySelector('.sz-rd-cartqv__left')) { var t = document.createElement('span'); t.className = 'sz-rd-cartqv__left'; t.textContent = 'Only ' + cap.stock + ' in stock'; li.querySelector('.sz-rd-cartqv__row').after(t); }
      });
    });
  }
  function render(c) {
    cart = c;
    setTimeout(function () { applyStock(c); }, 0);
    var n = c ? c.item_count : 0;
    count.textContent = n ? '(' + n + ')' : '';
    if (!n) { list.innerHTML = ''; empty.hidden = false; foot.hidden = true; return; }
    empty.hidden = true; foot.hidden = false;
    var nctx = nudgeCtx(c.items);
    /* BAG-GROUPS-1013 (owner 2026-10-13): with any pre-order line, in-stock lines first under "In stock", then pre-order lines
       under "Pre-order", each heading saying when it ships (same rule as the bag page). */
    var preItems = c.items.filter(function (it) { return !!it.selling_plan_allocation; }), inItems = c.items.filter(function (it) { return !it.selling_plan_allocation; });
    var preDates = {}; preItems.forEach(function (it) { var d = ((it.properties || {}).Shipping || '').trim(); if (d) preDates[d] = 1; });
    var pd = Object.keys(preDates), grouped = preItems.length > 0;
    var heads = { in: '<li class="sz-rd-cartqv__group">In stock <span>Ships first, on the next dispatch day</span></li>', pre: '<li class="sz-rd-cartqv__group">Pre-order <span>Ships later' + (pd.length === 1 ? (/^within/i.test(pd[0]) ? ', ' + esc(pd[0].toLowerCase()) : ', by ' + esc(pd[0])) : ', on the date shown for each') + '</span></li>' };
    var ordered = grouped ? inItems.concat(preItems) : c.items;
    list.innerHTML = ordered.map(function (it, i) {
      var head = !grouped ? '' : (i === 0 && inItems.length ? heads.in : '') + (it === preItems[0] ? heads.pre : '');
      return head + lineHtml(it);
    }).join('');
    guardImages();
    paintShip(c);
    function lineHtml(it) {
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<span class="sz-rd-cartqv__variant">' + esc(it.variant_title) + '</span>' : '';
      var sp = split(it);
      var plan = '';
      if (sp) {
        plan = '<div class="sz-rd-cartqv__pay">' +
          '<span class="sz-rd-cartqv__pay-now"><b>' + money(sp.today) + '</b> today</span>' +
          '<span class="sz-rd-cartqv__pay-later"><b>' + money(sp.later) + '</b> ' + (sp.date ? dueWhen(sp.date, false) : 'before it ships') + '</span>' +
        '</div>';
      } else if (it.selling_plan_allocation) {
        // JS-BAG-1014: the "Pay in full today" plan has no deposit to show
        var spn = (it.selling_plan_allocation.selling_plan && it.selling_plan_allocation.selling_plan.name) || '';
        plan = '<span class="sz-rd-cartqv__plan">' + (/in full/i.test(spn) ? 'Pre-order · paid in full today' : 'Pre-order · deposit at checkout') + '</span>';
      }
      /* BONUS-1014: the email bonus shrimp is one free line: no quantity buttons, says Free when the code took it to $0 */
      if (String(it.product_type) === 'Bonus') {
        return '<li class="sz-rd-cartqv__line sz-rd-cartqv__line--bonus" data-key="' + esc(it.key) + '">' +
          '<span class="sz-rd-cartqv__img">' + img(it) + '</span>' +
          '<div class="sz-rd-cartqv__body">' +
            '<span class="sz-rd-cartqv__name">Bonus shrimp</span>' +
            '<span class="sz-rd-cartqv__variant">We pack 1 extra from a shrimp line in your order</span>' +
            '<div class="sz-rd-cartqv__row">' +
              '<span class="sz-rd-cartqv__bonus">Free bonus</span>' +
              '<span class="sz-rd-cartqv__price">' + (it.final_line_price > 0 ? money(it.final_line_price) : 'Free') + '</span>' +
              '<button type="button" class="sz-rd-cartqv__remove" data-sz-rd-cartqv-remove aria-label="Remove the bonus shrimp">Remove</button>' +
            '</div>' +
          '</div>' +
        '</li>';
      }
      return '<li class="sz-rd-cartqv__line" data-key="' + esc(it.key) + '">' +
        '<a class="sz-rd-cartqv__img" href="' + esc(it.url) + '">' + img(it) + '</a>' +
        '<div class="sz-rd-cartqv__body">' +
          '<a class="sz-rd-cartqv__name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant + plan + nudge(it, nctx) +
          '<div class="sz-rd-cartqv__row">' +
            '<div class="sz-rd-qty sz-rd-qty--sm" role="group" aria-label="Quantity">' +
              '<button type="button" class="sz-rd-qty__btn" data-sz-rd-cartqv-dec aria-label="Decrease quantity">−</button>' +
              '<span class="sz-rd-qty__input sz-rd-cartqv__qty" data-sz-rd-cartqv-qty>' + it.quantity + '</span>' +
              '<button type="button" class="sz-rd-qty__btn" data-sz-rd-cartqv-inc aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<span class="sz-rd-cartqv__price">' + money(it.final_line_price) + '</span>' +
            '<button type="button" class="sz-rd-cartqv__remove" data-sz-rd-cartqv-remove aria-label="Remove ' + esc(it.product_title) + '">Remove</button>' +
          '</div>' +
        '</div>' +
      '</li>';
    }
    /* DEAL-10P5-ORDER-1019: the 10 + 5 deal is now an ORDER discount, which items_subtotal_price does not include, so the
       Subtotal under "Savings" would still show the pre-deal amount. total_price is after every discount (and before
       shipping); with line discounts only, the two are the same number, so nothing else moves. */
    var sub = c.total_price != null ? c.total_price : c.items_subtotal_price;
    subtotal.textContent = money(sub);
    var savEl = qv.querySelector('[data-sz-rd-cartqv-savings]'), savAmt = qv.querySelector('[data-sz-rd-cartqv-savings-amt]');
    if (savEl && savAmt) { var off = c.total_discount || 0; savEl.hidden = !(off > 0); savAmt.textContent = off > 0 ? '−' + money(off) : ''; }
    // Footer split: what the card is charged today vs. later. A line with no plan is due in
    // full today; a plan line adds its deposit today and its balance later. If any plan line
    // cannot be split honestly (discounted, see split()), the footer shows no split at all
    // rather than a confident wrong number one tap from checkout.
    var today = 0, later = 0, dates = {}, ok = true, anyPlan = false;
    c.items.forEach(function (it) {
      var sp = split(it);
      if (sp) { anyPlan = true; today += sp.today; later += sp.later; if (sp.date) dates[sp.date] = 1; }
      else if (it.selling_plan_allocation) { ok = false; }
      else { today += it.final_line_price; }
    });
    var dl = Object.keys(dates);
    if (splitEl) {
      if (anyPlan && ok && later > 0) {
        var when = dl.length === 1 ? dueWhen(dl[0], true) : 'Before your shipping date' + (dl.length > 1 ? 's' : '');
        splitEl.innerHTML =
          '<div class="sz-rd-cartqv__due"><span>Due today</span><b>' + money(today) + '</b></div>' +
          '<div class="sz-rd-cartqv__due sz-rd-cartqv__due--later"><span>' + when + '</span><b>' + money(later) + '</b></div>';
        splitEl.hidden = false;
        if (noteEl) noteEl.textContent = 'The balance is charged automatically to the same card before your shipping date, and we email you first. Shipping is added at checkout.';
      } else {
        splitEl.hidden = true; splitEl.innerHTML = '';
        if (noteEl) noteEl.textContent = noteDefault;
      }
    }
  }
  /* Deposit split for one line, or null when it cannot be stated honestly. Same rule as
     the cart page (sections/sz-rd-cart.liquid, measured 2026-08-15): checkout_charge_amount
     is PER UNIT and is resolved before discount Functions run, so a discounted line gets no
     split. The ship date is the `Shipping` line property STOQ writes at add time. */
  /* LIVE-QA-1014 #5: the Shipping property is either a date ("24 Oct") or a window ("Within 21 days of
     your order"); "before Within 21 days" read wrong, so a window is shown as it is. */
  function dueWhen(d, cap) {
    d = String(d);
    if (/^within/i.test(d)) return '<em class="sz-rd-cartqv__date">' + esc(cap ? d.charAt(0).toUpperCase() + d.slice(1) : d.charAt(0).toLowerCase() + d.slice(1)) + '</em>';
    return (cap ? 'Before' : 'before') + ' <em class="sz-rd-cartqv__date">' + esc(d) + '</em>';
  }
  function split(it) {
    var a = it.selling_plan_allocation;
    if (!a) return null;
    var per = a.checkout_charge_amount;
    var props = it.properties || {};
    if (per == null && a.selling_plan && a.selling_plan.checkout_charge && a.selling_plan.checkout_charge.value_type === 'percentage') {
      per = Math.round(it.final_price * Number(a.selling_plan.checkout_charge.value) / 100);
    }
    if (per == null) {
      /* Measured 2026-09-09: /cart.js gives the allocation WITHOUT checkout_charge_amount or the
         plan's checkout_charge, so the deposit has to come from what STOQ writes on the line —
         "Pay 50% now …" in the "Reserve now, pay later" property. The store runs one pre-order
         plan at 50% (SellingPlan/697748390200, GOTCHAS #91), which is the fallback when the
         property is absent; a plan at another rate would need the property to say so. */
      var own = Number(props._szdep);
      var m = /(\d{1,3})\s*%\s*(now|deposit)/i.exec(String(props['Reserve now, pay later'] || ''));
      // Our own _szdep note (theme-owned plans, 2026-09-09) wins; STOQ's wording is the fallback;
      // with neither the line is shown as due in full — never a guess.
      var pct = own > 0 && own < 100 ? own : (m ? Number(m[1]) : 0);
      if (!pct) return null;
      if (pct > 0 && pct < 100) per = Math.round(it.final_price * pct / 100);
    }
    if (!per || per <= 0) return null;
    var today = per * it.quantity;
    if (today > it.final_line_price || it.final_line_price < it.original_line_price) return null;
    var date = props.Shipping || props.shipping || '';
    return { today: today, later: it.final_line_price - today, date: String(date) };
  }
  function load() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c) render(c); })
      .catch(function () {});
  }
  function change(key, q) {
    if (busy) return;
    busy = true; qv.setAttribute('aria-busy', 'true');
    qv.querySelectorAll('[data-sz-rd-cartqv-inc], [data-sz-rd-cartqv-dec], [data-sz-rd-cartqv-remove]').forEach(function (button) { button.disabled = true; });
    var activeRow = Array.from(qv.querySelectorAll('.sz-rd-cartqv__line')).find(function (row) { return row.getAttribute('data-key') === key; });
    var activeQuantity = activeRow && activeRow.querySelector('[data-sz-rd-cartqv-qty]');
    if (activeQuantity) activeQuantity.textContent = String(q);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: q }),
    })
      .then(function (r) { if (!r.ok) throw new Error('change failed'); return r.json(); })
      .then(function (c) {
        render(c);
        if (window.szRdSyncCart) window.szRdSyncCart();
        document.dispatchEvent(new CustomEvent('sz:cart-updated', { detail: { cart: c } }));
      })
      .catch(function () { window.alert('Unable to update this quantity. Please check stock and try again.'); return load(); })
      .finally(function () { busy = false; qv.removeAttribute('aria-busy'); qv.querySelectorAll('[data-sz-rd-cartqv-inc], [data-sz-rd-cartqv-dec], [data-sz-rd-cartqv-remove]').forEach(function (button) { button.disabled = false; }); });
  }
  function open(from) {
    opener = from || null;
    stockNote = ''; sayStock('');
    qv.hidden = false; if (scrim) scrim.hidden = false;
    document.documentElement.classList.add('sz-rd-cartqv-open');
    var go = function () { qv.classList.add('is-open'); if (scrim) scrim.classList.add('is-open'); }; requestAnimationFrame(go); setTimeout(go, 30);
    load().then(function () { if (closeBtn) closeBtn.focus(); });
  }
  function close() {
    qv.classList.remove('is-open'); if (scrim) scrim.classList.remove('is-open');
    document.documentElement.classList.remove('sz-rd-cartqv-open');
    setTimeout(function () { if (qv.classList.contains("is-open")) return; qv.hidden = true; if (scrim) scrim.hidden = true; }, 820);
    if (opener && opener.focus) opener.focus();
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var op = t.closest('[data-sz-rd-cart-open]');
    if (op) { e.preventDefault(); open(op); return; }
    if (t.closest('[data-sz-rd-cartqv-close]') || (scrim && t === scrim)) { close(); return; }
    var line = t.closest('.sz-rd-cartqv__line');
    if (!line || !cart) return;
    var key = line.getAttribute('data-key');
    var it = cart.items.filter(function (x) { return x.key === key; })[0];
    if (!it) return;
    if (t.closest('[data-sz-rd-cartqv-inc]')) { var capQ = stockCaps[key]; if (capQ && it.quantity >= capQ.max) return; change(key, Math.min(99, it.quantity + 1)); }
    else if (t.closest('[data-sz-rd-cartqv-dec]')) change(key, Math.max(0, it.quantity - 1));
    else if (t.closest('[data-sz-rd-cartqv-remove]')) { if (busy) return; line.hidden = true; change(key, 0); } /* REMOVE-1TAP-1013: gone at once, not after the save */
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !qv.hidden) close(); });
  // keep the panel honest if the PDP edits a line while it is open
  document.addEventListener('sz:cart-updated', function (e) { if (!qv.hidden && e.detail && e.detail.cart) render(e.detail.cart); });
  window.szRdCartQuickView = { open: open, close: close };
})();
/* Menus collapse on page scroll (owner 2026-09-08: "drop down menu auto collapse if
   scrolling somewhere else"). Phone: a window scroll while the slide-down menu is open
   means the page behind was scrolled — close the open group and the menu. Desktop: the
   hover/focus dropdown is CSS-only, so a scroll adds a suppress class (removed on the next
   pointer move) and drops nav focus. */
(function () {
  var root = document.documentElement;
  var menu = document.querySelector('[data-sz-rd-menu]');
  var burger = document.querySelector('[data-sz-rd-burger]');
  var lastY = window.scrollY, drOpenedAt = 0, drOpenY = 0;
  new MutationObserver(function () {
    if (document.body.classList.contains('sz-rd-menu-open') && !drOpenedAt) { drOpenedAt = performance.now(); drOpenY = window.scrollY; }
    else if (!document.body.classList.contains('sz-rd-menu-open')) drOpenedAt = 0;
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  window.addEventListener('scroll', function () {
    var y = window.scrollY;
    if (Math.abs(y - lastY) < 4) return;
    lastY = y;
    if (menu && document.body.classList.contains('sz-rd-menu-open')) {
      /* PREMIUM-UI-02 (2026-10-06): the side drawer (.sz-dr) is a modal overlay. Opening it can
         nudge the page by scroll anchoring or trackpad momentum, which closed it within ~10 ms.
         For the drawer: ignore the first 500 ms and close only after a real scroll (>120 px). */
      if (menu.classList.contains('sz-dr')) {
        if (performance.now() - drOpenedAt < 500 || Math.abs(y - drOpenY) < 120) return;
      }
      menu.querySelectorAll('.sz-rd-menu__group[open]').forEach(function (d) { d.open = false; });
      if (burger) burger.click();
    }
    root.classList.add('sz-rd-nav-suppress');
    var a = document.activeElement;
    if (a && a.closest && a.closest('.sz-rd-nav') && a.blur) a.blur();
  }, { passive: true });
  window.addEventListener('pointermove', function () { root.classList.remove('sz-rd-nav-suppress'); }, { passive: true });
})();
/* Description sub-section labels (owner 2026-09-09: "'At a glance' and 'Description' sound
   confusing and not accurate"). The rows come from each product's own copy (.sz-acc), so
   the wording is mapped here once for every product instead of editing 50 descriptions;
   the source copy is unchanged. */
(function () {
  var isShrimp = !!document.querySelector('.sz-rd-pdp[data-genus]');
  var map = {
    'at a glance': 'Quick facts',
    'description': isShrimp ? 'About this shrimp' : 'About this product',
    'colour & care': 'Colour & care',
    'color & care': 'Colour & care',
    'grading': 'Grades explained'
  };
  document.querySelectorAll('.sz-acc__row > span').forEach(function (sp) {
    var key = sp.textContent.trim().toLowerCase();
    if (map[key]) sp.textContent = map[key];
  });
})();

/* Outside-tap close for the phone menu + focus drop for the desktop dropdown (owner
   2026-09-09: "the drop down menu still not collapse when hover/clicking outside the
   menu"). The phone panel slides down under the header with no scrim, so a tap on the page
   beneath used to land on the page and leave the menu open. Now a pointer landing outside
   the panel and the header closes it, and the click that follows is swallowed so the tap
   only dismisses (a tap on another header control — cart, search — closes the menu AND
   still works). Escape closes too. Desktop: the dropdown is CSS :hover / :focus-within; a
   click can leave focus inside the nav and hold it open, so a pointer landing outside the
   nav blurs it. */
(function () {
  var menu = document.querySelector('[data-sz-rd-menu]');
  var burger = document.querySelector('[data-sz-rd-burger]');
  function menuOpen() { return document.body.classList.contains('sz-rd-menu-open'); }
  function closeMenu() {
    if (!menu || !menuOpen()) return false;
    menu.querySelectorAll('.sz-rd-menu__group[open]').forEach(function (d) { d.open = false; });
    document.body.classList.remove('sz-rd-menu-open');
    if (burger) burger.setAttribute('aria-expanded', 'false');
    return true;
  }
  document.addEventListener('pointerdown', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    // desktop dropdown: drop nav focus when the pointer lands elsewhere
    var a = document.activeElement;
    if (a && a.closest && a.closest('.sz-rd-nav') && !t.closest('.sz-rd-nav') && a.blur) a.blur();
    if (!menuOpen()) return;
    if (t.closest('[data-sz-rd-menu]') || t.closest('[data-sz-rd-burger]')) return;
    var inHeader = !!t.closest('.sz-rd-header');
    if (closeMenu() && !inHeader) {
      var swallow = function (ev) { ev.preventDefault(); ev.stopPropagation(); ev.stopImmediatePropagation(); off(); };
      var off = function () { document.removeEventListener('click', swallow, true); };
      document.addEventListener('click', swallow, true);
      setTimeout(off, 500);
    }
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && closeMenu() && burger) burger.focus(); });
})();
/* Card thumbnail carousel (owner 2026-09-09: "arrows to click back and forth to preview the
   shrimp"). One delegated handler for every [data-sz-rd-card-prev/next]: pick the next slide
   (wrapping), give it its src the first time (the markup carries data-src so a listing does
   not download every photo of every product up front), swap the is-on class on slide and
   dot. The press is stopped from bubbling so neither the media link nor the whole-card
   tap handler navigates. */
(function () {
  function show(wrap, idx) {
    var slides = wrap.querySelectorAll('.sz-rd-card__slide');
    var dots = wrap.querySelectorAll('.sz-rd-card__dots i');
    if (!slides.length) return;
    var n = slides.length; idx = ((idx % n) + n) % n;
    var next = slides[idx];
    if (next.dataset.src) {
      if (next.dataset.srcset) { next.srcset = next.dataset.srcset; delete next.dataset.srcset; }
      next.src = next.dataset.src; delete next.dataset.src;
    }
    slides.forEach(function (s, i) { s.classList.toggle('is-on', i === idx); });
    dots.forEach(function (d, i) { d.classList.toggle('is-on', i === idx); });
    wrap.dataset.szRdIdx = String(idx);
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest('[data-sz-rd-card-prev], [data-sz-rd-card-next]');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    var wrap = btn.closest('.sz-rd-card__mediawrap');
    if (!wrap) return;
    var cur = Number(wrap.dataset.szRdIdx || 0);
    show(wrap, btn.hasAttribute('data-sz-rd-card-next') ? cur + 1 : cur - 1);
  }, true);
})();
/* Rail edge state (2026-09-09): is-scrolled once a row has moved, is-end when it shows its
   last card — the desktop fade reads these so the row never fades an edge that has nothing
   beyond it. Passive scroll listeners; recomputed on resize. */
(function () {
  var rows = Array.prototype.slice.call(document.querySelectorAll('[data-sz-rd-row]'));
  if (!rows.length) return;
  function paint(row) {
    var max = row.scrollWidth - row.clientWidth;
    row.classList.toggle('is-scrolled', row.scrollLeft > 4);
    row.classList.toggle('is-end', max <= 4 || row.scrollLeft >= max - 4);
  }
  rows.forEach(function (row) {
    row.addEventListener('scroll', function () { paint(row); }, { passive: true });
    paint(row);
  });
  window.addEventListener('resize', function () { rows.forEach(paint); }, { passive: true });
  window.addEventListener('load', function () { rows.forEach(paint); });
})();

/* Keep typed product quantities consistent with the existing 1-99 controls. */
(() => {
  const selector = 'input[data-sz-rd-qty]';
  function normalize(input, commit) {
    if (!(input instanceof HTMLInputElement) || !input.matches(selector)) return;
    if (!commit && (input.value.trim() === '' || input.validity.badInput)) return;
    const lower = Number(input.min || 1);
    const upper = input.max === '' ? Number.MAX_SAFE_INTEGER : Number(input.max);
    const minimum = Number.isFinite(lower) ? lower : 1;
    const maximum = Number.isFinite(upper) ? Math.max(minimum, upper) : Number.MAX_SAFE_INTEGER;
    const parsed = Number(input.value);
    const quantity = input.value.trim() !== '' && Number.isFinite(parsed) ? Math.trunc(parsed) : minimum;
    input.value = String(Math.min(maximum, Math.max(minimum, quantity)));
  }
  document.addEventListener('input', event => normalize(event.target, false), true);
  document.addEventListener('change', event => normalize(event.target, true), true);
  document.addEventListener('focusout', event => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.matches(selector)) return;
    const previous = input.value;
    normalize(input, true);
    if (input.value !== previous) input.dispatchEvent(new Event('input', { bubbles: true }));
  }, true);
})();

/* A bulk tile selects a quantity; Shopify remains authoritative for discounts. */
(() => {
  document.addEventListener('click', event => {
    const tile = event.target instanceof Element ? event.target.closest('[data-sz-rd-tier]') : null;
    if (!tile || tile.disabled || tile.closest('[hidden]')) return;
    const form = tile.closest('form');
    const input = form?.querySelector('input[data-sz-rd-qty]');
    const requested = Number(tile.dataset.qty);
    if (!input || !Number.isSafeInteger(requested) || requested < 1) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const minimum = Number(input.min) || 1;
    const maximum = Number(input.max) || 99;
    const quantity = Math.max(minimum, Math.min(maximum, requested));
    input.value = String(quantity);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    form.querySelectorAll('[data-sz-rd-tier]').forEach(option => {
      const selected = option === tile && quantity === requested;
      option.setAttribute('aria-pressed', String(selected));
      option.classList.toggle('is-active', selected);
    });
  }, true);
})();

/* The cart reloads after saving: block checkout from the first edit until then. */
(() => {
  let saving = false;
  const edits = '[data-sz-rd-line-plus], [data-sz-rd-line-minus], [data-sz-rd-line-remove]';
  const isCheckout = control => control && (
    control.getAttribute('name') === 'checkout' ||
    /^(checkout|check out)$/i.test(control.textContent.trim()) ||
    (control.tagName === 'A' && /\/checkouts?(?:[/?#]|$)/.test(control.getAttribute('href') || ''))
  );
  function block(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
  window.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const edit = event.target.closest(edits);
    if (edit && !edit.disabled) {
      saving = true;
      document.querySelectorAll('button, input[type="submit"], a').forEach(control => {
        if (!isCheckout(control)) return;
        control.setAttribute('aria-disabled', 'true');
        if ('disabled' in control) control.disabled = true;
        if (!document.getElementById('sz-cart-saving-status')) {
          const message = document.createElement('p');
          message.id = 'sz-cart-saving-status';
          message.setAttribute('role', 'status');
          message.textContent = 'Saving quantities. Checkout will be available when your cart updates.';
          control.after(message);
        }
      });
      return;
    }
    if (saving && isCheckout(event.target.closest('button, input, a'))) block(event);
  }, true);
  window.addEventListener('submit', event => {
    if (saving && (isCheckout(event.submitter) || event.target.querySelector('[name="checkout"]'))) block(event);
  }, true);
})();

/* JS-BAG-1014: one last stock check on the way to checkout. Buy-now lines on continue-policy grades are capped only
   by this theme (Shopify would sell past stock), and the bag page / panel enable Checkout before their own check has
   finished, so a quick tap could carry an over-stock line to checkout. If the check trims the bag, the shopper lands
   on the bag page with the usual note instead; if it cannot run (network), checkout goes ahead as before. */
(() => {
  let going = false;
  function guard(event, proceed) {
    if (!window.szStock || going) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    going = true;
    const done = () => { going = false; };
    fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then((r) => (r.ok ? r.json() : null))
      .then((cart) => (cart ? window.szStock.enforce(cart) : null))
      .then((r) => {
        if (r && r.changed) {
          try { sessionStorage.setItem('szStockNote', r.note); } catch (e) { /* ignore */ }
          window.location.href = '/cart';
          return;
        }
        proceed();
      })
      .catch(() => proceed())
      .then(() => setTimeout(done, 4000));
  }
  window.addEventListener('click', (e) => {
    const a = e.target instanceof Element && e.target.closest('a.sz-rd-cartqv__checkout');
    if (a && !e.defaultPrevented) guard(e, () => { window.location.href = a.href; });
  }, true);
  window.addEventListener('submit', (e) => {
    const form = e.target;
    if (e.defaultPrevented || !(form instanceof HTMLFormElement) || !form.matches('[data-sz-rd-checkout-form]')) return;
    if (!(e.submitter && e.submitter.name === 'checkout')) return;
    guard(e, () => {
      if (!form.querySelector('input[type="hidden"][name="checkout"]')) {
        const i = document.createElement('input');
        i.type = 'hidden'; i.name = 'checkout'; i.value = e.submitter.value || '';
        form.appendChild(i);
      }
      HTMLFormElement.prototype.submit.call(form);
    });
  }, true);
})();

/* Shift an open dropdown only as far as needed to clear either screen edge. */
(() => {
  const selector = '.sz-rd-header .sz-rd-nav__drop';
  let scheduled = false;
  function fitMenus() {
    scheduled = false;
    document.querySelectorAll(selector).forEach(menu => {
      menu.style.removeProperty('translate');
      if (!matchMedia('(min-width: 1280px)').matches || !menu.getClientRects().length) return;
      const bounds = menu.getBoundingClientRect();
      const edge = 16;
      const width = document.documentElement.clientWidth;
      let offset = 0;
      if (bounds.left < edge) offset = edge - bounds.left;
      if (bounds.right + offset > width - edge) offset += width - edge - (bounds.right + offset);
      if (offset) menu.style.translate = `${Math.round(offset)}px 0`;
    });
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(fitMenus);
  }
  document.addEventListener('pointerover', event => {
    if (event.target instanceof Element && event.target.closest('.sz-rd-nav__item')) schedule();
  });
  document.addEventListener('focusin', event => {
    if (event.target instanceof Element && event.target.closest('.sz-rd-nav__item')) schedule();
  });
  window.addEventListener('resize', schedule, { passive: true });
})();

/* Show shipping progress again on upward scroll, without moving the page.
   BAND-RETURN-01 (owner 2026-10-09, phone screenshot of the strip over the open menu: "Fix the shipping progress bar again",
   "The top banner should say we are new store as well"): the returning strip is now a copy of the whole green band, so it
   carries the new-store note as well as the shipping meter (and follows the band's empty-bag rule), and it stays hidden
   while the menu, a side sheet, the photo zoom or the bag panel is open. */
(() => {
  function initShippingReturn() {
    const original = document.querySelector('.sz-rd-announce-band') || document.querySelector('.sz-rd-announce');
    if (!original || document.querySelector('.sz-shipping-return')) return;
    const copy = original.cloneNode(true);
    copy.classList.add('sz-shipping-return');
    copy.setAttribute('aria-hidden', 'true');
    copy.hidden = true;
    function clean() {
      [copy, ...copy.querySelectorAll('*')].forEach(element => {
        element.removeAttribute('id');
        [...element.attributes].forEach(attribute => {
          if (attribute.name.startsWith('data-')) element.removeAttribute(attribute.name);
        });
      });
      copy.querySelectorAll('a, button').forEach(el => el.setAttribute('tabindex', '-1'));
      copy.toggleAttribute('data-cart-empty', original.hasAttribute('data-cart-empty'));
    }
    clean();
    document.body.append(copy);
    new MutationObserver(() => {
      copy.innerHTML = original.innerHTML;
      clean();
    }).observe(original, { childList: true, subtree: true, characterData: true, attributes: true });
    const root = document.documentElement;
    function overlayOpen() {
      return document.body.classList.contains('sz-rd-menu-open') || root.classList.contains('sz-pm-sheet-open') ||
        root.classList.contains('sz-rd-cartqv-open') || root.classList.contains('sz-rd-search-open') || root.classList.contains('sz-signup-open');
    }
    /* SCROLL-SYNC-1015 (owner 2026-10-15 "banner and bottom navbar are not very sync and feel sketchy"): measured on the
       live home page (iPhone 13 frame test), the strip hid on ANY 1 px downward move, came back after 24 px up, and both it
       and the header jumped 32 px in one frame with no animation, while the Pips bubble ran on its own timer. Now one
       direction detector: 48 px of upward travel = "up", 24 px of downward travel = "down" (small thumb wobbles do nothing),
       the strip slides in/out on a transition and the header glides with it (sz-pm-fixes.css), a flip holds for 350 ms, the
       top 80 px and the bottom rubber-band are ignored, and the strip's height is measured once (not every frame). The
       detector also announces `sz:scrolldir` on <html> so the Pips bubble (sz-pips-dock.js) moves on the same cue. */
    const DOWN = 24, UP = 48, DWELL = 350;
    let previous = Math.max(0, window.scrollY);
    let upward = 0, downward = 0, dir = 0, scheduled = false, on = false, flippedAt = 0, height = 0, hideTimer = 0;
    function announce(next) {
      if (next === dir) return;
      dir = next;
      root.dispatchEvent(new CustomEvent('sz:scrolldir', { detail: { dir: next > 0 ? 'down' : 'up' } }));
    }
    function set(next, now) {
      if (next === on) return;
      const t = performance.now();
      if (!now && t - flippedAt < DWELL) return;
      flippedAt = t; on = next;
      clearTimeout(hideTimer);
      if (next) {
        copy.hidden = false;
        if (!height) height = copy.offsetHeight;
        /* class and header offset in the same frame, so the strip and the header start moving together */
        requestAnimationFrame(() => { if (!on) return; copy.classList.add('is-on'); root.style.setProperty('--sz-shipping-height', `${height}px`); });
      } else {
        copy.classList.remove('is-on');
        root.style.setProperty('--sz-shipping-height', '0px');
        if (now) copy.hidden = true;
        else hideTimer = setTimeout(() => { if (!on) copy.hidden = true; }, 320);
      }
      root.classList.toggle('sz-shipping-visible', next);
    }
    function update() {
      scheduled = false;
      const max = Math.max(0, root.scrollHeight - window.innerHeight);
      const current = Math.min(max, Math.max(0, window.scrollY));
      const delta = current - previous;
      previous = current;
      if (overlayOpen()) { upward = downward = 0; set(false, true); return; }
      if (current >= max - 2) return;
      if (delta > 0) { downward += delta; upward = 0; if (downward >= DOWN) announce(1); }
      else if (delta < 0) { upward -= delta; downward = 0; if (upward >= UP) announce(-1); }
      if (current < 80) { set(false); return; }
      if (dir > 0 && downward >= DOWN) set(false);
      else if (dir < 0 && upward >= UP) set(true);
    }
    function schedule() {
      if (!scheduled) { scheduled = true; requestAnimationFrame(update); }
    }
    window.addEventListener('resize', () => { height = 0; if (on) { height = copy.offsetHeight; root.style.setProperty('--sz-shipping-height', `${height}px`); } }, { passive: true });
    window.addEventListener('scroll', schedule, { passive: true });
    const watch = new MutationObserver(() => { if (overlayOpen() && !copy.hidden) update(); });
    watch.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    watch.observe(root, { attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initShippingReturn, { once: true });
  else initShippingReturn();
})();

/* Two-line grade availability, kept in sync with variant painting. */
(() => {
  const icons = {
    in: '<path d="m4 8 3 3 5-6"/>',
    pre: '<rect x="2" y="3" width="12" height="11" rx="2"/><path d="M5 1v4m6-4v4M2 7h12"/>',
    out: '<path d="M3 8h10"/>'
  };
  function paintGrades() {
    document.querySelectorAll('[data-sz-rd-opt]').forEach(group => {
      if (!/grade/i.test(group.querySelector('legend')?.textContent || '')) return;
      if (!group.classList.contains('sz-grade-group')) group.classList.add('sz-grade-group');
      group.querySelectorAll('[data-sz-rd-optval]').forEach(pill => {
        const state = pill.dataset.state;
        const name = pill.dataset.szRdOptval;
        if (!name || !icons[state]) return;
        const label = { in: 'In stock', pre: 'Pre-order', out: 'Sold out' }[state];
        pill.setAttribute('aria-pressed', String(pill.classList.contains('is-active')));
        if (pill.dataset.statusPainted === `${name}:${state}`) return;
        pill.dataset.statusPainted = `${name}:${state}`;
        pill.classList.add('sz-grade-status');
        const title = document.createElement('span');
        title.className = 'sz-grade-status__name';
        title.textContent = name;
        const status = document.createElement('span');
        status.className = 'sz-grade-status__availability';
        status.innerHTML = `<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${icons[state]}</svg>`;
        status.append(document.createTextNode(label));
        pill.replaceChildren(title, status);
        pill.setAttribute('aria-label', `${name}, ${label}`);
      });
    });
  }
  let scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; paintGrades(); });
  }
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-state', 'class'] });
  schedule();
})();

/* Keep the appearance control beside search in the shared header. */
(() => {
  let toggle;
  let scheduled = false;
  function position() {
    scheduled = false;
    const headerToggle = document.querySelector('.sz-rd-header__icons [data-sz-theme-toggle]');
    if (headerToggle) return;
    const controls = [...document.querySelectorAll('[aria-label], [title]')].filter(el =>
      /^(switch to|enable) (light|dark) theme$/i.test(el.getAttribute('aria-label') || el.getAttribute('title') || '')
    );
    if (!toggle?.isConnected) toggle = controls[0];
    if (!toggle) return;
    controls.forEach(other => { if (other !== toggle) other.style.setProperty('display', 'none', 'important'); });
    if (toggle.parentElement !== document.body) document.body.append(toggle);
    toggle.classList.add('sz-theme-by-pips');
    const pip = document.getElementById('sz-concierge-launcher');
    const bounds = pip?.getBoundingClientRect();
    const visible = bounds && bounds.width > 0 && bounds.height > 0 && bounds.top < innerHeight;
    const right = 8;
    const bottom = visible ? Math.max(16, innerHeight - bounds.top + 8) : 100;
    const x = `${Math.round(right)}px`, y = `${Math.round(bottom)}px`;
    if (toggle.style.right !== x) toggle.style.setProperty('right', x, 'important');
    if (toggle.style.bottom !== y) toggle.style.setProperty('bottom', y, 'important');
  }
  function schedule() { if (!scheduled) { scheduled = true; requestAnimationFrame(position); } }
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-label', 'title'] });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('scroll', schedule, { passive: true });
  schedule();
})();

/* Retain the cart delivery state across quantity-save reloads in this tab. */
(() => {
  if (!/\/cart\/?$/.test(location.pathname)) return;
  const states = new Set([
    'VIC', 'NSW', 'QLD', 'SA', 'ACT', 'WA', 'TAS', 'NT',
    'VICTORIA', 'NEW SOUTH WALES', 'QUEENSLAND', 'SOUTH AUSTRALIA',
    'AUSTRALIAN CAPITAL TERRITORY', 'WESTERN AUSTRALIA', 'TASMANIA', 'NORTHERN TERRITORY'
  ]);
  const key = 'sz-cart-delivery-state-v1';
  function stateOf(input) {
    if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return null;
    const state = input.value.trim().toUpperCase();
    return states.has(state) ? state : null;
  }
  document.addEventListener('change', event => {
    const state = stateOf(event.target);
    if (!state || !event.target.checked) return;
    try { sessionStorage.setItem(key, state); } catch (_) {}
  }, true);
  function restore() {
    let saved;
    try { saved = sessionStorage.getItem(key); } catch (_) { return; }
    if (!states.has(saved)) return;
    const inputs = [...document.querySelectorAll('input[type="radio"]')].filter(input => stateOf(input));
    if (inputs.some(input => input.checked)) return;
    const input = inputs.find(input => stateOf(input) === saved);
    // A native click also re-runs delivery eligibility and shipping-rate logic.
    if (input && !input.disabled) input.click();
  }
  const schedule = () => requestAnimationFrame(restore);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
  else schedule();
})();

/* Show mobile bottom navigation only after intentional upward page scrolling. */
(function () {
  var bar = document.querySelector('.sz-rd-tabbar');
  if (!bar) return;
  var root = document.documentElement;
  var mobile = window.matchMedia('(max-width: 767px)');
  var last = Math.max(0, window.scrollY), travel = 0, direction = 0;
  function show(visible) {
    if (bar.hasAttribute('data-sz-split-nav') && mobile.matches) visible = true;
    root.classList.toggle('sz-mobile-nav-visible', visible);
    bar.inert = mobile.matches && !visible;
  }
  function reset() {
    root.classList.toggle('sz-mobile-scrollnav', mobile.matches);
    last = Math.max(0, window.scrollY); travel = 0; direction = 0;
    show(false);
  }
  reset();
  mobile.addEventListener('change', reset);
  window.addEventListener('scroll', function () {
    if (!mobile.matches) return;
    var max = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    var y = Math.min(max, Math.max(0, window.scrollY));
    var delta = y - last; last = y;
    if (!delta) return;
    var next = delta > 0 ? 1 : -1;
    if (next !== direction) { direction = next; travel = 0; }
    travel += Math.abs(delta);
    if (travel < 10) return;
    if (next < 0) show(true);
    else if (!bar.contains(document.activeElement)) show(false);
  }, { passive: true });
})();
/* TABBAR-TUCK-1016 (owner 2026-10-16 "Push c live", option C on the design canvas): on phones the bottom menu bar slides
   off the bottom while the page scrolls down and comes back on scroll up, on the same cue (sz:scrolldir from the top-strip
   controller: 24 px down / 48 px up) as the top strip and the Pips bubble, so card buttons are never stuck under it.
   Always shown in the top 80 px, while an overlay is open, or while focus is inside the bar. */
(function () {
  var bar = document.querySelector('.sz-rd-tabbar');
  if (!bar) return;
  var root = document.documentElement;
  var mobile = window.matchMedia('(max-width: 767px)');
  function overlayOpen() {
    return document.body.classList.contains('sz-rd-menu-open') || root.classList.contains('sz-pm-sheet-open') ||
      root.classList.contains('sz-rd-cartqv-open') || root.classList.contains('sz-rd-search-open') || root.classList.contains('sz-signup-open');
  }
  function tuck(on) {
    if (on && (!mobile.matches || window.scrollY < 80 || overlayOpen() || bar.contains(document.activeElement))) on = false;
    if (root.classList.contains('sz-tabbar-tucked') === on) return;
    root.classList.toggle('sz-tabbar-tucked', on);
    bar.inert = on;
  }
  var down = false;
  root.addEventListener('sz:scrolldir', function (e) { down = !!(e.detail && e.detail.dir === 'down'); tuck(down); });
  /* the down cue can fire inside the top 80 px (where the bar must stay), so re-check once the page passes 80 px */
  window.addEventListener('scroll', function () { tuck(down && window.scrollY >= 80); }, { passive: true });
  new MutationObserver(function () { if (overlayOpen()) tuck(false); }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  mobile.addEventListener('change', function () { tuck(false); });
  window.addEventListener('pageshow', function () { tuck(false); });
})();
/* NAV-04: Pips floats clear of the measured bottom bar; no app changes needed.
   SCROLL-SYNC-1015: this block used to ALSO hide/show the launcher on its own 10 px / 800 ms rule, fighting
   sz-pips-dock.js (whose inline !important styles always won). It now only keeps --sz-pips-nav-height current. */
(function () {
  var root = document.documentElement;
  var mobile = window.matchMedia('(max-width: 767px)');
  var bar = document.querySelector('.sz-rd-tabbar');
  function clearance() {
    if (!mobile.matches) { root.style.removeProperty('--sz-pips-nav-height'); return; }
    var height = 0;
    if (bar && (!bar.inert || root.classList.contains('sz-tabbar-tucked')) && getComputedStyle(bar).visibility !== 'hidden' && getComputedStyle(bar).display !== 'none') {
      /* TABBAR-TUCK-1016: the bar's own height, even mid-slide, so Pips docks above where the bar comes back to */
      height = bar.getBoundingClientRect().height;
    }
    var value = height > 0 ? Math.ceil(height) + 'px' : 'env(safe-area-inset-bottom, 0px)';
    if (root.style.getPropertyValue('--sz-pips-nav-height') !== value) root.style.setProperty('--sz-pips-nav-height', value);
  }
  root.classList.remove('sz-pips-hidden');
  mobile.addEventListener('change', clearance);
  window.addEventListener('resize', clearance, { passive: true });
  window.addEventListener('pageshow', clearance);
  if (bar && window.ResizeObserver) new ResizeObserver(clearance).observe(bar);
  new MutationObserver(clearance).observe(root, { attributes: true, attributeFilter: ['class'] });
  clearance();
})();

/* Native modal supplies focus containment and Escape without a custom trap. */
(function () {
  var trigger = document.querySelector('[data-sz-more-open]');
  var dialog = document.getElementById('sz-mobile-more');
  if (!trigger || !dialog) return;
  var mobile = window.matchMedia('(max-width: 767px)');
  function close() {
    trigger.setAttribute('aria-expanded', 'false');
    if (dialog.open) dialog.close();
  }
  trigger.addEventListener('click', function () {
    if (!mobile.matches || dialog.open) return;
    dialog.showModal(); trigger.setAttribute('aria-expanded', 'true');
  });
  dialog.addEventListener('close', function () {
    trigger.setAttribute('aria-expanded', 'false');
    if (mobile.matches) trigger.focus({ preventScroll: true });
  });
  dialog.addEventListener('click', function (event) {
    if (event.target.closest('[data-sz-more-close],a')) { close(); return; }
    var r = dialog.getBoundingClientRect();
    if (event.target === dialog && (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom)) close();
  });
  mobile.addEventListener('change', function () { if (!mobile.matches) close(); });
})();

/* BONUS-1014 (owner 2026-10-14, abandoned-checkout email 3, "Option 1"): the email's button opens the store with
   ?sz_bonus=1. With 5 or more shrimp in the bag (Caridina / Neocaridina / Sulawesi), the hidden "Bonus shrimp" product
   (tag sz-bonus, $15) goes in as its own line and the code BONUSSHRIMP (100% off that product only, once per customer,
   combines with everything) is applied, so bulk savings and deals on the shrimp lines are untouched. Fewer than 5
   shrimp: the bag says how many more; the bonus is added as soon as there are 5. Removing the bonus, or placing the
   order, ends the offer on this device. A bonus line with no live offer is taken out. The flag lives 14 days. */
(function () {
  'use strict';
  var qv = document.querySelector('[data-sz-rd-cartqv]');
  var BONUS = qv ? Number(qv.getAttribute('data-sz-bonus-variant')) : 0;
  if (!BONUS || window.__szBonus) return;
  window.__szBonus = true;
  var KEY = 'sz:bonus', CODE = 'BONUSSHRIMP', MIN = 5, DAYS = 14;
  var SHRIMP = /^(caridina|neocaridina|sulawesi) shrimp$/i;
  var json = { 'Content-Type': 'application/json', Accept: 'application/json' };
  function getFlag() { try { var f = JSON.parse(localStorage.getItem(KEY) || 'null'); return f && Date.now() - f.t < DAYS * 864e5 ? f : null; } catch (e) { return null; } }
  function setFlag(f) { try { if (f) localStorage.setItem(KEY, JSON.stringify(f)); else localStorage.removeItem(KEY); } catch (e) {} }
  function cartJs() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }); }
  function post(url, body) { return fetch(url, { method: 'POST', headers: json, body: JSON.stringify(body) }).then(function (r) { if (!r.ok) throw new Error(url); return r.json(); }); }
  var busy = false, onCartPage = location.pathname.replace(/\/$/, '') === '/cart';

  function note(text) {
    var foot = qv.querySelector('[data-sz-rd-cartqv-foot]'); if (!foot) return;
    var el = foot.querySelector('[data-sz-bonus-note]');
    if (!el) { el = document.createElement('p'); el.className = 'sz-rd-cartqv__bonusnote'; el.setAttribute('data-sz-bonus-note', ''); el.setAttribute('aria-live', 'polite'); foot.insertBefore(el, foot.firstChild); }
    el.textContent = text || ''; el.hidden = !text;
  }
  function shrimpIn(c) { return c.items.reduce(function (n, it) { return n + (SHRIMP.test(String(it.product_type || '').trim()) ? it.quantity : 0); }, 0); }

  function reconcile(c) {
    if (!c || busy) return Promise.resolve(c);
    var flag = getFlag();
    var line = c.items.filter(function (it) { return Number(it.variant_id) === BONUS; })[0];
    var n = shrimpIn(c);
    if (flag && flag.added && !c.item_count) { setFlag(null); flag = null; } /* ordered (or emptied) after the bonus went in */
    var codes = (c.discount_codes || []).map(function (d) { return d.code; });
    var hasCode = codes.some(function (x) { return String(x).toUpperCase() === CODE; });
    var job = null;
    if (line && (!flag || n < MIN)) job = function () { return post('/cart/change.js', { id: line.key, quantity: 0 }); };
    else if (line && line.quantity > 1) job = function () { return post('/cart/change.js', { id: line.key, quantity: 1 }); };
    else if (flag && n >= MIN && !line) job = function () { return post('/cart/add.js', { items: [{ id: BONUS, quantity: 1 }] }).then(cartJs); };
    else if (line && flag && !hasCode) job = function () { return post('/cart/update.js', { discount: codes.concat(CODE).join(',') }); };
    note(flag && n < MIN && c.item_count ? 'Add ' + (MIN - n) + ' more shrimp and we’ll add your free bonus shrimp.' : '');
    if (!job) return Promise.resolve(c);
    busy = true;
    return job().then(function (c2) { return c2 && c2.items ? c2 : cartJs(); }).then(function (c2) {
      busy = false;
      var l2 = c2 && c2.items.filter(function (it) { return Number(it.variant_id) === BONUS; })[0];
      if (l2 && flag) { flag.added = true; setFlag(flag); }
      if (window.szRdSyncCart) window.szRdSyncCart();
      document.dispatchEvent(new CustomEvent('sz:cart-updated', { detail: { cart: c2, source: 'bonus' } }));
      if (onCartPage) { location.reload(); return c2; }
      return reconcile(c2); /* one more pass: e.g. add the code after adding the line */
    }).catch(function () { busy = false; return c; });
  }

  /* the bonus line was removed by the shopper: the offer ends on this device */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.sz-rd-cartqv__line--bonus [data-sz-rd-cartqv-remove], [data-sz-bonus-remove]');
    if (t) setFlag(null);
  }, true);
  document.addEventListener('sz:cart-updated', function (e) { var d = e.detail || {}; if (d.source !== 'bonus' && d.cart) reconcile(d.cart); });
  document.addEventListener('sz-rd:added', function () { setTimeout(function () { cartJs().then(reconcile); }, 600); });

  var params = new URLSearchParams(location.search);
  var fromEmail = params.has('sz_bonus');
  if (fromEmail) {
    setFlag({ t: Date.now(), added: false });
    params.delete('sz_bonus');
    var rest = params.toString();
    history.replaceState(null, '', location.pathname + (rest ? '?' + rest : '') + location.hash);
  }
  if (fromEmail || getFlag()) { /* no extra /cart.js read on ordinary page views; a stray bonus line is caught on the next bag change */
    cartJs().then(reconcile).then(function () {
      if (fromEmail && !onCartPage && window.szRdCartQuickView) window.szRdCartQuickView.open();
    });
  }
})();
